// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-09-10T15:42:00.990Z
// Property: Cedar Ridge Apartments (ID: 6767906449165589)
// Collections: 30 amenities, 9 floorplans (live), 38 photos, 66 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165589",
  "property_external_id": "zfwbjyw",
  "property_zillow_url": "https://www.zillow.com/b/cedar-ridge-apartments-tulsa-ok-Brc4LJ/",
  "property_apartments_url": "https://www.apartments.com/cedar-ridge-apartments-tulsa-ok/zfwbjyw/",
  "property_google_business_url": "https://www.google.com/maps/place/Cedar+Ridge/data=!4m2!3m1!1s0x0:0xb658c515f85c29e6?sa=X&ved=2ahUKEwjSlOWd87ySAxXGnGoFHUc5HOUQ_BJ6BAg8EAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cedar-ridge-apartments",
  "property_name": "Cedar Ridge Apartments",
  "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/cedar-ridge/",
  "property_domain": null,
  "property_address": "11100 E. 96th St. S.",
  "property_full_address": "11100 E. 96th St. S., Tulsa, OK, 74133",
  "property_address_1": "11100 E. 96th St. S.",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74133",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa",
  "property_address_latitude": "36.0275",
  "property_address_longitude": "-95.8547",
  "property_email": "cedarridge@caseusa.com",
  "property_phone": "(539) 666-1483",
  "property_call_tracking_phone": "855-605-2070",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "<p>At Cedar Ridge Apartments in Tulsa, you’ll find thoughtfully designed one, two, and three-bedroom homes that combine comfort and style. Enjoy resort-style amenities, from a refreshing pool and state-of-the-art fitness center to tranquil outdoor spaces. Elevate your living experience—check availability and schedule your tour today! Prefer to explore on your own time? Self-guided tours are available.</p>",
  "property_long_description": "Welcome to Cedar Ridge Apartments, where modern living meets convenience in the heart of Tulsa, Oklahoma! Our thoughtfully designed apartment community offers an array of spacious floor plans, including one, two, and three-bedroom options tailored to your lifestyle. With a variety of premium amenities at your fingertips, Cedar Ridge is the perfect place to call home.\n\nEnjoy sunny afternoons lounging by the refreshing pool or entertaining friends on the sundeck with a BBQ at the grill or in our picturesque picnic area. Stay active in our state-of-the-art fitness center, or unwind in the elegant clubhouse. Our gated community boasts controlled access, on-site maintenance, and a dedicated property manager to ensure both comfort and security. \n\nPet lovers will rejoice in our pet play area, while professionals can take advantage of our on-site business center and high-speed internet access. Every unit is designed with your needs in mind, featuring air conditioning, stainless steel appliances, walk-in closets, and modern finishes like tile floors and vaulted ceilings. Almost all apartments offer balconies or patios to enjoy the beautiful outdoors right from your home.\n\nWith conveniences such as package service, online services, and 24-hour access, Cedar Ridge Apartments provide a lifestyle designed for modern living. Don’t miss out! Find your new home today—browse our availability or schedule a tour to visit our vibrant community! Experience the perfect blend of comfort and convenience at Cedar Ridge.",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-22a5-7338-b12c-2cd51ef834d3.webp",
  "property_featured_image_media": {
    "alt_text": "Exterior of apartment building with balconies and landscaping.",
    "public_id": "019cfb3a-22a5-7338-b12c-2cd51ef834d3",
    "storage_key": "property/6767906449165589/019cfb3a-22a5-7338-b12c-2cd51ef834d3.webp",
    "width": 1000,
    "height": 600
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "337",
  "property_year_built": "2020",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "96.73590504451039",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": "225-425",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Breed Restrictions Apply",
  "property_pet_policy_description": "80lbs max;; 0-80lbs",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://cedarridgeapartmentstulsa.securecafe.com/onlineleasing/cedar-ridge-apartments1/floorplans.aspx",
  "property_resident_portal_url": "https://cedarridgeapartmentstulsa.securecafe.com/residentservices/cedar-ridge-apartments1/userlogin.aspx",
  "property_apply_now_url": "https://caseusa.securecafe.com/onlineleasing/cedar-ridge-apartments1/register.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-8a94-773d-b77e-156844fbd052.webp",
  "property_primary_logo_media": {
    "alt_text": "Cedar Ridge Apartment Homes logo",
    "public_id": "019cfb3a-8a94-773d-b77e-156844fbd052",
    "storage_key": "property/6767906449165589/019cfb3a-8a94-773d-b77e-156844fbd052.webp",
    "width": 300,
    "height": 160
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3b-d045-7658-9a93-7806f1479875.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb3b-d045-7658-9a93-7806f1479875",
    "storage_key": "property/6767906449165589/019cfb3b-d045-7658-9a93-7806f1479875.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3b-ef76-745e-ae34-e572d46c2d34.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Cedar Ridge Apartment Homes logo",
    "public_id": "019cfb3b-ef76-745e-ae34-e572d46c2d34",
    "storage_key": "property/6767906449165589/019cfb3b-ef76-745e-ae34-e572d46c2d34.webp",
    "width": 300,
    "height": 160
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3b-fc48-73fe-8cf0-3db979a0ae95.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Cedar Ridge Apartment Homes logo",
    "public_id": "019cfb3b-fc48-73fe-8cf0-3db979a0ae95",
    "storage_key": "property/6767906449165589/019cfb3b-fc48-73fe-8cf0-3db979a0ae95.webp",
    "width": 300,
    "height": 160
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#463567",
  "property_secondary_color": "#7564a0",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#cac4b8",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 1",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "1",
  "property_bathrooms_range": "1 - 1",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "1",
  "property_sqft_range": "789 - 966",
  "property_sqft_min": "789",
  "property_sqft_max": "966",
  "property_price_range": "1209 - 1624",
  "property_price_min": "1209",
  "property_price_max": "1624",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/media/set/?vanity=CedarRidgeApt&set=a.494449936022869",
  "property_instagram_url": "https://www.instagram.com/cedarridgeapartmentstulsa/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ2bS0oSiPtocR5ilc-BXFWLY",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/cedar-ridge-tulsa-2",
  "property_tiktok_url": "https://www.tiktok.com/@cedarridgeapartments",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cedar Ridge Apartments",
  "property_home_romance_title": "Embrace a Life of Comfort and Connection at Our Community",
  "property_home_amenities_blurb": "Welcome to Cedar Ridge Apartments in picturesque Tulsa, Oklahoma, where comfort meets style. Choose from thoughtfully designed one, two, or three-bedroom floor plans adorned with modern amenities. Enjoy leisurely afternoons by the pool, invigorating workouts in the fitness center, or cozy gatherings in the clubhouse. Your ideal home awaits!",
  "property_home_floorplans_blurb": "Welcome to Cedar Ridge Apartments in the heart of Tulsa, Oklahoma, where modern living meets comfort. Choose from our thoughtfully designed one, two, or three-bedroom floor plans, each tailored to enhance your lifestyle. Take a moment to browse our available homes and discover the perfect fit for your needs.",
  "property_home_gallery_blurb": "Nestled in the heart of Tulsa, Cedar Ridge Apartments offers spacious one, two, and three-bedroom floor plans designed for modern living. Enjoy resort-style amenities from a sparkling pool to a cozy clubhouse, while your furry friends roam in the pet play area. Picture yourself living here—where comfort meets convenience!",
  "property_home_neighborhood_blurb": "At Cedar Ridge Apartments in Tulsa, Oklahoma, home is more than just a floor plan—it’s a gateway to adventure. Enjoy nearby parks, vibrant local attractions, and the educational offerings nearby. With one, two, or three-bedroom options, your ideal living space awaits. Dive into community favorites and discover your neighborhood gems!",
  "property_home_reviews_blurb": "At Cedar Ridge Apartments in Tulsa, our residents’ happiness shines through their words. “I absolutely love living here! The space feels like a home,\" reflects our commitment to creating a welcoming community. With exceptional maintenance and beautifully kept grounds, it’s a place you’ll be proud to call home. Join us today!",
  "property_neighborhood_blurb": "At Cedar Ridge Apartments, life thrives amidst diverse attractions in Tulsa. Enjoy seamless access to parks, educational institutions like Oral Roberts University, and fitness centers, all within reach. From the tranquil Haikey Creek Park to the dynamic Tulsa Community College, there’s something for everyone. Uncover the vibrant community around you!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cedar Ridge Apartments in Tulsa, your dream lifestyle awaits! Enjoy luxurious one-, two-, or three-bedroom homes featuring modern amenities like stainless steel appliances, walk-in closets, and spacious balconies. Dive into our sparkling pool, stay fit in the gym, or unwind at the cabana — your ideal retreat starts here!",
  "property_applynow_blurb": "At Cedar Ridge Apartments in Tulsa, your ideal home awaits! Choose from spacious one, two, or three-bedroom floor plans, featuring modern amenities like a refreshing pool, a state-of-the-art fitness center, and cozy courtyards. Embrace a vibrant lifestyle—lease online today and elevate your living experience!",
  "property_contactus_blurb": "At Cedar Ridge Apartments in Tulsa, Oklahoma, find the perfect floor plan tailored to your lifestyle—choose from airy one, spacious two, or luxurious three-bedroom options. Our leasing team is ready to answer your questions and help you discover your new home. Reach out today for personalized assistance!",
  "property_faqs_blurb": "At Cedar Ridge Apartments in Tulsa, Oklahoma, we cater to every lifestyle with thoughtfully designed one, two, and three-bedroom floor plans. Have questions? Our FAQs page offers insights into community living, amenities, and more. Dive in to find the answers you need for a seamless transition to your new home!",
  "property_floorplans_blurb": "At Cedar Ridge Apartments in Tulsa, Oklahoma, choose from our thoughtfully designed one, two, and three-bedroom floor plans tailored to fit your lifestyle. With space and style in mind, each apartment feels like home. Browse our available options and discover the ideal layout that suits your needs.",
  "property_gallery_blurb": "At Cedar Ridge Apartments in Tulsa, every moment is a breath of fresh air. Revel in spacious floor plans—from one to three bedrooms—crafted for comfort and style. Luxuriate poolside, unleash your inner chef in our outdoor kitchen, or unwind in the pet-friendly courtyard. Picture yourself living here!",
  "property_interactivemap_blurb": "At Cedar Ridge Apartments in Tulsa, you’ll find thoughtfully designed one, two, and three-bedroom floor plans, complemented by top-notch amenities like a refreshing pool, a modern fitness center, and inviting outdoor spaces. Use our interactive community map to find your perfect home today, and elevate your lifestyle!",
  "property_pets_blurb": "Experience the charm of Cedar Ridge Apartments in Tulsa, OK, where modern living meets nature’s beauty. Nestled among lush landscapes, our pet-friendly community welcomes furry companions up to 80lbs, creating a home where both you and your pet can thrive. Find your sanctuary at Cedar Ridge today!",
  "property_referafriend_blurb": "At Cedar Ridge Apartments in Tulsa, Oklahoma, roomy floor plans await—choose from one, two, or three bedrooms tailored to your lifestyle. Enjoy a vibrant community where great friends become great neighbors. Share the joy of living here—refer a friend today and elevate your apartment experience together!",
  "property_residentaccess_blurb": "Welcome home to Cedar Ridge Apartments in beautiful Tulsa, Oklahoma! Choose from our thoughtfully designed one, two, or three-bedroom floor plans that cater to your lifestyle. Access your resident portal effortlessly to pay rent, schedule maintenance, and enjoy a seamless living experience right at your fingertips.",
  "property_reviews_blurb": "At Cedar Ridge Apartments in Tulsa, residents thrive in a vibrant community that feels like home. As one satisfied resident shared, \"The space feels like a home...the grounds are always well kept.\" With prompt maintenance and exceptional service, our apartments offer quality living you’ll love. Read more about our community!",
  "property_created_at": "1753982378936",
  "property_scheduletour_blurb": "At Cedar Ridge Apartments in Tulsa, Oklahoma, we offer thoughtfully designed one, two, and three bedroom floor plans tailored to your lifestyle. Come see firsthand the vibrant community we’ve cultivated—schedule a tour today and learn why our residents love calling Cedar Ridge home! Your perfect space awaits.",
  "property_thankyou_blurb": "Thank you for reaching out to Cedar Ridge Apartments in Tulsa! Our inviting community features thoughtfully designed one, two, and three-bedroom floor plans, perfect for every lifestyle. Stay tuned—our team will connect with you soon to help you find your ideal home in the heart of Tulsa!",
  "property_virtualtours_blurb": "At Cedar Ridge Apartments in Tulsa, Oklahoma, choose from thoughtfully designed one, two, or three-bedroom floor plans that suit your lifestyle. Immerse yourself in our community through an engaging virtual tour—experience the charm and comfort of your future home today!",
  "property_copyright": "2025 All Rights Reserved. Cedar Ridge Apartments",
  "property_seo_title_home": "Cedar Ridge Apartments |  Apartments in Tulsa, Oklahoma",
  "property_seo_description_home": "Welcome to Cedar Ridge Apartments in Tulsa! Enjoy stylish living with top-tier amenities, spacious floor plans, and a vibrant community. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Discover your ideal space at Cedar Ridge Apartments in Tulsa! Choose from one, two, or three-bedroom floor plans designed for comfort and style. Browse now!",
  "property_seo_title_amenities": "Amenities | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Experience Cedar Ridge Apartments in Tulsa, where luxury meets comfort! Enjoy our pool, fitness center, and spacious layouts. Your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, Oklahoma",
  "property_seo_description_gallery": "Experience the charm of Cedar Ridge Apartments in Tulsa, OK. Modern amenities await—imagine life by the pool, with spacious layouts and serene courtyards!",
  "property_seo_title_virtualtours": "Virtual Tours | Cedar Ridge Apartments Apartments",
  "property_seo_description_virtualtours": "Step inside Cedar Ridge Apartments in Tulsa! Enjoy spacious one to three-bedroom layouts. Take a virtual tour and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | Cedar Ridge Apartments Apartments",
  "property_seo_description_interactivemap": "Discover your ideal home at Cedar Ridge Apartments in Tulsa! Explore layouts, amenities, and prices using our interactive map. Your new lifestyle awaits!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the hidden gems near Cedar Ridge Apartments in Tulsa! From vibrant local favorites to must-visit spots, your ideal neighborhood awaits.",
  "property_seo_title_contact": "Contact Us | Cedar Ridge Apartments",
  "property_seo_description_contact": "Connect with Cedar Ridge Apartments in Tulsa! Whether you're eyeing a cozy one-bedroom or a spacious three-bedroom, our leasing team is here to assist you.",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, Oklahoma",
  "property_seo_description_faqs": "Find answers to your questions about Cedar Ridge Apartments in Tulsa. From amenities to floor plans, our FAQs page has everything you need for your new home!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, Oklahoma",
  "property_seo_description_reviews": "Discover vibrant living at Cedar Ridge Apartments in Tulsa! Enjoy our pool, fitness center, and pet play area. Join our happy residents today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, Oklahoma",
  "property_seo_description_applynow": "Experience the Cedar Ridge lifestyle in Tulsa! Stylish one, two, and three-bedroom apartments with top-notch amenities await. Lease your new home today!",
  "property_seo_title_residentaccess": "Resident Access | Cedar Ridge Apartments",
  "property_seo_description_residentaccess": "Log in to Cedar Ridge Apartments' resident portal! Pay rent, schedule maintenance, and manage your living experience in beautiful Tulsa, Oklahoma.",
  "property_seo_title_referafriend": "Refer A Friend | Cedar Ridge Apartments",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to Cedar Ridge Apartments in Tulsa today and elevate your community experience together.",
  "property_seo_title_scheduletour": "Schedule a Tour | Cedar Ridge Apartments",
  "property_seo_description_scheduletour": "Experience the charm of Cedar Ridge Apartments in Tulsa. Schedule a tour today and find your perfect home in our vibrant community!",
  "property_seo_title_privacy": "Privacy Policy | Cedar Ridge Apartments",
  "property_seo_description_privacy": "Protect your peace of mind at Cedar Ridge Apartments, Tulsa! Dive into our privacy policy to learn how we safeguard your information. Your trust matters!",
  "property_seo_title_accessibility": "Website Accessibility | Cedar Ridge Apartments",
  "property_seo_description_accessibility": "Experience seamless living at Cedar Ridge Apartments in Tulsa, where accessibility meets comfort. We value digital inclusion for all residents. Join us today!",
  "property_seo_title_sitemap": "Sitemap | Cedar Ridge Apartments",
  "property_seo_description_sitemap": "Navigate Cedar Ridge Apartments in Tulsa with ease! Check out our sitemap for a quick guide to our community amenities and available floor plans.",
  "property_seo_title_thankyou": "Thank You | Cedar Ridge Apartments",
  "property_seo_description_thankyou": "Thank you for reaching out to Cedar Ridge Apartments in Tulsa! Exciting living awaits—our team will connect with you soon to help you find your perfect home!",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1789054845062",
  "amenities": [
    {
      "id": "ec_be4d331285a66aba5f8e7b03",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127456687",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8efb897986599256d79124e3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127456706",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_13f6b94d8947e4b7331fa06a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127396297",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8020170ab0985f3b548a6da2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127396300",
      "title": "Controlled Access/Gated",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_88ec053c7b5a1688f8e23721",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127396301",
      "title": "24- Hour Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_1b32e1c26d567482103852a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127396302",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a3f75cc845d9f14f4250e128",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127396303",
      "title": "Resort Style Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bfbaee424080df7ef10ce0d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127396304",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_380bab2bb61aedca5e08027c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127396305",
      "title": "High Speed Internet",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0bb72f9518221344e7cd3880",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127396306",
      "title": "Package Receiving",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_705333119baaa059379763d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127396307",
      "title": "Availability 24 Hours",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0806025a27b2c6ba6d0d3f9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127456705",
      "title": "Courtesy Patrol",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_27db641176ce77fbcc71f1d6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127396308",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_353f04fd4df19e3b598146bf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127456709",
      "title": "Garages Available *",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_563797ca9537f622f4e07dfd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "128033179",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5ffa68f83386790cd904dcf0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127397806",
      "title": "Electronic Thermostat",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_515000932055f0df7b9d2088",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127397807",
      "title": "Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c38151030991e7eda04ebce7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127397808",
      "title": "Dishwasher",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d6b5110b239eb2c77c4ad5aa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127397809",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8b52116552aef113e8853b3b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127397810",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9ec062f73a50ddb2f40385e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127397811",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8ff7ade3436b4347a817bc71",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127397812",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9b4371766c6b2dd2277101b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127397813",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_93676a9a6414442acb401f28",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127397814",
      "title": "Refrigerator",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a59ff2c51fdf290e3af4c43e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127397815",
      "title": "Washer/Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c117f2ac00c2839d77016eaa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127397817",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc5d17df02805051dbae93d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127397818",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_115127453ef23319b39385cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127397819",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d267df02e45ec2c21a3cf309",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127397820",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_da9d4233fb4d935a76c8f78a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "yardi",
      "external_id": "127456256",
      "title": "Extra Storage*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_81be856f-191b-409f-89a3-7fc92e412b6e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ba-0c06-718e-8896-29fd95b96b5b.webp",
      "image_media": {
        "alt_text": "Aerial view of a multifamily property with a pond and nearby highway.",
        "public_id": "019f70ba-0c06-718e-8896-29fd95b96b5b",
        "storage_key": "property/6767906449165589/019f70ba-0c06-718e-8896-29fd95b96b5b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Expansive aerial view showcasing a multifamily property with a serene pond, lush landscaping, and convenient access to a major highway.",
      "link": "",
      "alt_text": "Aerial view of a multifamily property with a pond and nearby highway.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7dabfff0-b2de-4056-9ae0-e2f06995bb6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ba-0594-74e7-9ca9-2809996e7a70.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and manicured landscaping.",
        "public_id": "019f70ba-0594-74e7-9ca9-2809996e7a70",
        "storage_key": "property/6767906449165589/019f70ba-0594-74e7-9ca9-2809996e7a70.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautifully designed apartment buildings featuring private balconies and lush green spaces, offering a comfortable and inviting living environment.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with balconies and manicured landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_07d02c2a-10d9-44c9-be42-a663a016b56d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b9-feff-755f-b139-1ce74b78b0d7.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with built-in chaise lounges and water features.",
        "public_id": "019f70b9-feff-755f-b139-1ce74b78b0d7",
        "storage_key": "property/6767906449165589/019f70b9-feff-755f-b139-1ce74b78b0d7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing day at the resort-style swimming pool, complete with comfortable chaise lounges and refreshing water fountains.",
      "link": "",
      "alt_text": "Outdoor swimming pool with built-in chaise lounges and water features.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6ce7c7c9-0a62-4bb8-b49a-bf70f8b703cc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b9-ea5e-765a-aac0-d8d65096a269.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool and cabana area with lounge chairs at Cedar Ridge apartments.",
        "public_id": "019f70b9-ea5e-765a-aac0-d8d65096a269",
        "storage_key": "property/6767906449165589/019f70b9-ea5e-765a-aac0-d8d65096a269.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling outdoor pool or relax in the shade of the cabana. This resort-style amenity is perfect for unwinding and soaking up the sun.",
      "link": "",
      "alt_text": "Outdoor swimming pool and cabana area with lounge chairs at Cedar Ridge apartments.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_effeb688-b3fb-4cf8-a272-ef691130ca87",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b9-ea6b-727f-9b1f-18d3bbff6fe3.webp",
      "image_media": {
        "alt_text": "Outdoor grilling area with picnic table and grills, with apartment buildings in the background.",
        "public_id": "019f70b9-ea6b-727f-9b1f-18d3bbff6fe3",
        "storage_key": "property/6767906449165589/019f70b9-ea6b-727f-9b1f-18d3bbff6fe3.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy outdoor cooking at our community grilling stations, perfect for gathering with friends and family.",
      "link": "",
      "alt_text": "Outdoor grilling area with picnic table and grills, with apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_fc294e0c-0eda-466b-9665-e837e29c07a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b9-eaa9-741b-bb18-6e4aa319dfe4.webp",
      "image_media": {
        "alt_text": "Luxury swimming pool with lounge chairs and umbrellas in a multifamily property.",
        "public_id": "019f70b9-eaa9-741b-bb18-6e4aa319dfe4",
        "storage_key": "property/6767906449165589/019f70b9-eaa9-741b-bb18-6e4aa319dfe4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a relaxing day by the stunning outdoor swimming pool, complete with comfortable lounge chairs and shade umbrellas. Perfect for soaking up the sun and unwinding.",
      "link": "",
      "alt_text": "Luxury swimming pool with lounge chairs and umbrellas in a multifamily property.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_23eb395e-0120-48e0-8991-41c217a5baf6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b9-e910-71ca-bcd1-fbda4640f8af.webp",
      "image_media": {
        "alt_text": "Outdoor fire pit with blue glass and seating area in front of building with large garage-style door.",
        "public_id": "019f70b9-e910-71ca-bcd1-fbda4640f8af",
        "storage_key": "property/6767906449165589/019f70b9-e910-71ca-bcd1-fbda4640f8af.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Gather around the fire pit and enjoy the outdoors with friends and neighbors. This inviting community space features comfortable seating and a modern fire feature, perfect for relaxing evenings.",
      "link": "",
      "alt_text": "Outdoor fire pit with blue glass and seating area in front of building with large garage-style door.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_01d267b6-a036-46d8-99c0-345c5b1f9518",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b9-e844-746f-b753-00799f48bbba.webp",
      "image_media": {
        "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas.",
        "public_id": "019f70b9-e844-746f-b753-00799f48bbba",
        "storage_key": "property/6767906449165589/019f70b9-e844-746f-b753-00799f48bbba.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and shaded umbrellas. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Aerial view of a resort-style swimming pool with lounge chairs and umbrellas.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_632d49ee-f252-4e2c-aa5b-9f3116458ebb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b9-c39c-7679-9769-3498457ae2b1.webp",
      "image_media": {
        "alt_text": "Cedar Ridge Apartments monument sign and building exterior with parking lot",
        "public_id": "019f70b9-c39c-7679-9769-3498457ae2b1",
        "storage_key": "property/6767906449165589/019f70b9-c39c-7679-9769-3498457ae2b1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Cedar Ridge Apartments, featuring modern amenities and a prime location. This image showcases the property's inviting exterior and convenient parking.",
      "link": "",
      "alt_text": "Cedar Ridge Apartments monument sign and building exterior with parking lot",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_24936b30-f635-4fc2-af04-99bc687c519f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b9-c328-739b-a229-7a72a869659d.webp",
      "image_media": {
        "alt_text": "Exterior view of a modern multifamily apartment building with balconies and surrounding green space.",
        "public_id": "019f70b9-c328-739b-a229-7a72a869659d",
        "storage_key": "property/6767906449165589/019f70b9-c328-739b-a229-7a72a869659d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover modern apartment living with stunning exteriors and comfortable balconies, set within a beautifully landscaped community.",
      "link": "",
      "alt_text": "Exterior view of a modern multifamily apartment building with balconies and surrounding green space.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b7756477-a04d-48c9-8b8c-14cbe3fb75fa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b9-c1ec-745c-ad37-95b2fcb599df.webp",
      "image_media": {
        "alt_text": "Exterior of apartment buildings with a lake in the foreground.",
        "public_id": "019f70b9-c1ec-745c-ad37-95b2fcb599df",
        "storage_key": "property/6767906449165589/019f70b9-c1ec-745c-ad37-95b2fcb599df.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Beautiful apartment complex featuring modern buildings with balconies, overlooking a serene lake and green spaces. Perfect for a peaceful living experience.",
      "link": "",
      "alt_text": "Exterior of apartment buildings with a lake in the foreground.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d78bc3de-cd79-43ca-8d98-47750ee6d288",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b8-e1ca-77f1-ba05-a45b0e47a486.webp",
      "image_media": {
        "alt_text": "Bathroom with a washer and dryer, vanity with marble countertop, and a colorful shower curtain.",
        "public_id": "019f70b8-e1ca-77f1-ba05-a45b0e47a486",
        "storage_key": "property/6767906449165589/019f70b8-e1ca-77f1-ba05-a45b0e47a486.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment bathroom features a modern vanity with ample storage, a stacked washer and dryer, and a vibrant floral shower curtain for a pop of color.",
      "link": "",
      "alt_text": "Bathroom with a washer and dryer, vanity with marble countertop, and a colorful shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b1af9fb9-dfce-4b4a-8461-802352a30ec7",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b8-cbc9-76be-9bec-87a275494e71.webp",
      "image_media": {
        "alt_text": "Living room with a teal sofa, fireplace, and view of a bedroom.",
        "public_id": "019f70b8-cbc9-76be-9bec-87a275494e71",
        "storage_key": "property/6767906449165589/019f70b8-cbc9-76be-9bec-87a275494e71.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern living room featuring a comfortable teal sofa, electric fireplace, and a peek into a well-appointed bedroom, perfect for relaxing and entertaining.",
      "link": "",
      "alt_text": "Living room with a teal sofa, fireplace, and view of a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2d52ae11-9a3c-417e-8cf8-7b9a68aa053d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b8-d3af-752a-8d32-a7310ed60026.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019f70b8-d3af-752a-8d32-a7310ed60026",
        "storage_key": "property/6767906449165589/019f70b8-d3af-752a-8d32-a7310ed60026.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "This apartment kitchen features dark wood cabinetry, a stainless steel microwave and oven, and beautiful marble countertops. Perfect for any home chef!",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_5e6e14f2-4f59-4292-a2de-f315028af370",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b8-ced1-747a-bca2-93a5432b8587.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
        "public_id": "019f70b8-ced1-747a-bca2-93a5432b8587",
        "storage_key": "property/6767906449165589/019f70b8-ced1-747a-bca2-93a5432b8587.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring dark wood cabinetry, stainless steel appliances including a refrigerator with ice dispenser, and elegant marble countertops. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel appliances, and marble countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dc9181d3-8334-4468-a6ee-dfc74bb2559b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b8-b5d6-728c-85e3-82e9f7098770.webp",
      "image_media": {
        "alt_text": "Living room with dining area, teal chaise lounge, and plush ottoman.",
        "public_id": "019f70b8-b5d6-728c-85e3-82e9f7098770",
        "storage_key": "property/6767906449165589/019f70b8-b5d6-728c-85e3-82e9f7098770.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Chic living and dining area featuring a teal chaise lounge, stylish seating, and elegant decor, perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "Living room with dining area, teal chaise lounge, and plush ottoman.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_51516d87-ada0-44ee-b3af-2e4a9b7bbb25",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b8-97ec-766a-b88c-c2d2ed8e9739.webp",
      "image_media": {
        "alt_text": "Bedroom with a queen-size bed, tufted headboard, and decorative wall art.",
        "public_id": "019f70b8-97ec-766a-b88c-c2d2ed8e9739",
        "storage_key": "property/6767906449165589/019f70b8-97ec-766a-b88c-c2d2ed8e9739.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A cozy and stylish bedroom featuring a comfortable queen-size bed, plush pillows, and elegant wall decor. Includes a spacious closet for ample storage.",
      "link": "",
      "alt_text": "Bedroom with a queen-size bed, tufted headboard, and decorative wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_78688040-f9d8-463c-96dc-6f048ad5557e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b8-9aab-716a-9d97-5283ce94e3b7.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving and two storage baskets with decorative pillows.",
        "public_id": "019f70b8-9aab-716a-9d97-5283ce94e3b7",
        "storage_key": "property/6767906449165589/019f70b8-9aab-716a-9d97-5283ce94e3b7.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet featuring ample wire shelving for storage and two decorative baskets with pillows, ready for your personal touch.",
      "link": "",
      "alt_text": "Empty walk-in closet with wire shelving and two storage baskets with decorative pillows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_43fe6c98-e9e1-4025-953b-68fb52c0d70c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b8-2e7f-76b4-839e-d5a81d57fa11.webp",
      "image_media": {
        "alt_text": "Stylish living room with vaulted ceilings, a modern kitchen with bar seating, a cozy fireplace, and a large sofa.",
        "public_id": "019f70b8-2e7f-76b4-839e-d5a81d57fa11",
        "storage_key": "property/6767906449165589/019f70b8-2e7f-76b4-839e-d5a81d57fa11.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this spacious apartment featuring a contemporary kitchen with bar seating, a relaxing living area with a fireplace, and elegant decor.",
      "link": "",
      "alt_text": "Stylish living room with vaulted ceilings, a modern kitchen with bar seating, a cozy fireplace, and a large sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_9584641d-4418-4b8f-a554-bd483bd21327",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b8-227d-7449-848d-7db62c44e1e8.webp",
      "image_media": {
        "alt_text": "Living room with a sofa, coffee table, and large windows.",
        "public_id": "019f70b8-227d-7449-848d-7db62c44e1e8",
        "storage_key": "property/6767906449165589/019f70b8-227d-7449-848d-7db62c44e1e8.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish and comfortable living room with plush seating and elegant decor, perfect for relaxation.",
      "link": "",
      "alt_text": "Living room with a sofa, coffee table, and large windows.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_63a0d3e7-3c62-42fb-9e14-7e004cc53f6a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b8-42a6-7402-b400-ee9315c93de6.webp",
      "image_media": {
        "alt_text": "Dining room with round table, four chairs, and abstract wall art.",
        "public_id": "019f70b8-42a6-7402-b400-ee9315c93de6",
        "storage_key": "property/6767906449165589/019f70b8-42a6-7402-b400-ee9315c93de6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Elegant dining area featuring a round table with four upholstered chairs, perfect for intimate meals or hosting guests. The space is enhanced by a modern abstract artwork and natural light from the adjacent balcony.",
      "link": "",
      "alt_text": "Dining room with round table, four chairs, and abstract wall art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_e8aeaf1e-af25-4b7f-99a6-fa4fdd73f68b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b8-1fae-7282-8e76-128ec6fe2312.webp",
      "image_media": {
        "alt_text": "Bathroom with vanity, sink, and floral shower curtain",
        "public_id": "019f70b8-1fae-7282-8e76-128ec6fe2312",
        "storage_key": "property/6767906449165589/019f70b8-1fae-7282-8e76-128ec6fe2312.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a modern vanity with a marble countertop, a deep sink, and a decorative mirror. Enjoy the vibrant floral shower curtain for a pop of color.",
      "link": "",
      "alt_text": "Bathroom with vanity, sink, and floral shower curtain",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_dc12b0b4-33fe-41a1-8528-aaf9a1874446",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b6-cccc-7209-8896-7d146a243e74.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, two nightstands, and a dresser.",
        "public_id": "019f70b6-cccc-7209-8896-7d146a243e74",
        "storage_key": "property/6767906449165589/019f70b6-cccc-7209-8896-7d146a243e74.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and unwind in this spacious and beautifully appointed bedroom, featuring a plush queen-size bed, elegant nightstands, and ample dresser space for all your storage needs.",
      "link": "",
      "alt_text": "Bedroom with a large bed, two nightstands, and a dresser.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7dc18d94-0d34-4d20-bf31-254fc9aff04d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b6-ba39-70e4-ba64-ca9ee436fefc.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, toilet, and shower with a striped curtain.",
        "public_id": "019f70b6-ba39-70e4-ba64-ca9ee436fefc",
        "storage_key": "property/6767906449165589/019f70b6-ba39-70e4-ba64-ca9ee436fefc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into a clean and updated bathroom, featuring a spacious vanity, toilet, and a bathtub/shower combination with a decorative curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a white vanity, toilet, and shower with a striped curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2fbb7433-bdcd-4466-ac93-f6bcce1939b1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b6-aec7-7316-beb9-115fed57594b.webp",
      "image_media": {
        "alt_text": "Desk with two lamps and a framed picture of a lightbulb.",
        "public_id": "019f70b6-aec7-7316-beb9-115fed57594b",
        "storage_key": "property/6767906449165589/019f70b6-aec7-7316-beb9-115fed57594b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A stylish desk adorned with decorative items, including lamps and a large framed artwork of a vintage lightbulb, creating an inviting entryway accent.",
      "link": "",
      "alt_text": "Desk with two lamps and a framed picture of a lightbulb.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2f18b5c8-984f-4e02-a255-c618e6b567d6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70b6-8396-74e8-9024-6d83fe52cdf2.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark cabinets and white marble countertops, open to living area with natural light.",
        "public_id": "019f70b6-8396-74e8-9024-6d83fe52cdf2",
        "storage_key": "property/6767906449165589/019f70b6-8396-74e8-9024-6d83fe52cdf2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern apartment kitchen featuring dark wood cabinetry, white marble countertops, a double sink, and stainless steel appliances. Adjacent living area with ample natural light.",
      "link": "",
      "alt_text": "Modern kitchen with dark cabinets and white marble countertops, open to living area with natural light.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_85e1dbeb-ca17-4bf2-bbfa-916596c96659",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ae-24db-73bc-8a58-a6c6fe63a423.webp",
      "image_media": {
        "alt_text": "Community lounge with pool table and shuffleboard.",
        "public_id": "019f70ae-24db-73bc-8a58-a6c6fe63a423",
        "storage_key": "property/6767906449165589/019f70ae-24db-73bc-8a58-a6c6fe63a423.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy downtime in our community lounge featuring a pool table and shuffleboard, perfect for friendly competition.",
      "link": "",
      "alt_text": "Community lounge with pool table and shuffleboard.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_88486ec4-3736-466a-b505-0a03ef7808dc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ae-0b01-7508-9ade-8328e788635f.webp",
      "image_media": {
        "alt_text": "Interior view of a modern apartment gym with weight machines, free weights, and a large mirror.",
        "public_id": "019f70ae-0b01-7508-9ade-8328e788635f",
        "storage_key": "property/6767906449165589/019f70ae-0b01-7508-9ade-8328e788635f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center. Enjoy a variety of weight machines and free weights to achieve your wellness goals.",
      "link": "",
      "alt_text": "Interior view of a modern apartment gym with weight machines, free weights, and a large mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_17e9d7df-4c82-41df-affe-1ac40a7f3560",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ad-f001-706f-8ec1-83c23a0a4351.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight racks, and free weights.",
        "public_id": "019f70ad-f001-706f-8ec1-83c23a0a4351",
        "storage_key": "property/6767906449165589/019f70ad-f001-706f-8ec1-83c23a0a4351.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring treadmills, ellipticals, weight machines, and free weights for a complete workout.",
      "link": "",
      "alt_text": "Fitness center with cardio machines, weight racks, and free weights.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_14703c27-ce7d-46e2-ae5d-0de0dd1f8a9f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ad-ed66-7023-acde-a9b3bbced26d.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and stationary bike.",
        "public_id": "019f70ad-ed66-7023-acde-a9b3bbced26d",
        "storage_key": "property/6767906449165589/019f70ad-ed66-7023-acde-a9b3bbced26d.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring treadmills, an elliptical, and a stationary bike. Enjoy your workout with scenic views.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and stationary bike.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8ae63477-58c6-4fdc-9b1b-ef2687f6bf73",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ad-d7a8-727f-b394-3393fe592ac2.webp",
      "image_media": {
        "alt_text": "View from private balcony overlooking a fenced yard and distant buildings.",
        "public_id": "019f70ad-d7a8-727f-b394-3393fe592ac2",
        "storage_key": "property/6767906449165589/019f70ad-d7a8-727f-b394-3393fe592ac2.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the outdoors from your private balcony, offering scenic views of the surrounding grounds and architecture. Perfect for relaxing or entertaining.",
      "link": "",
      "alt_text": "View from private balcony overlooking a fenced yard and distant buildings.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_aa27434a-9f8c-48f8-95f2-dd671f82d3e8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ab-7e3c-71ae-b42e-9222ba01b4c6.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-size bed, dresser, and nightstand.",
        "public_id": "019f70ab-7e3c-71ae-b42e-9222ba01b4c6",
        "storage_key": "property/6767906449165589/019f70ab-7e3c-71ae-b42e-9222ba01b4c6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Cozy and chic bedroom featuring a comfortable king-size bed, elegant dresser, and convenient nightstand, perfect for relaxation.",
      "link": "",
      "alt_text": "Stylish bedroom with a king-size bed, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_3b01eede-626d-4ebd-a0ce-05d69ed06208",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ab-1875-738b-860d-435e158f0612.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
        "public_id": "019f70ab-1875-738b-860d-435e158f0612",
        "storage_key": "property/6767906449165589/019f70ab-1875-738b-860d-435e158f0612.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious kitchen featuring stainless steel appliances, ample cabinet storage, and a sleek countertop. Perfect for cooking and entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances and white cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_202f1d53-8ea7-4c38-9e29-a21bbf27ff0f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ab-181c-72be-aed5-a9f8ed0812ea.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower with a blue raindrop shower curtain.",
        "public_id": "019f70ab-181c-72be-aed5-a9f8ed0812ea",
        "storage_key": "property/6767906449165589/019f70ab-181c-72be-aed5-a9f8ed0812ea.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Relax and refresh in this stylish bathroom, featuring a spacious vanity, modern fixtures, and a beautifully appointed shower with a unique blue raindrop shower curtain.",
      "link": "",
      "alt_text": "Modern bathroom with a vanity, sink, toilet, and shower with a blue raindrop shower curtain.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_ade04e53-3273-40fc-8967-0ce4791266fe",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70ab-0ec5-76a3-bb22-d5000d969986.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
        "public_id": "019f70ab-0ec5-76a3-bb22-d5000d969986",
        "storage_key": "property/6767906449165589/019f70ab-0ec5-76a3-bb22-d5000d969986.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this beautiful kitchen, featuring sleek stainless steel appliances, ample cabinet space, and elegant granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_10681c5c-28b8-46e2-a4d1-21108a191a91",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70a9-d259-74a1-9f82-3f2a8cabc9d0.webp",
      "image_media": {
        "alt_text": "Living room and kitchen area of an apartment with a sofa, TV, and breakfast bar.",
        "public_id": "019f70a9-d259-74a1-9f82-3f2a8cabc9d0",
        "storage_key": "property/6767906449165589/019f70a9-d259-74a1-9f82-3f2a8cabc9d0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious living and dining area with modern decor and a convenient breakfast bar, perfect for entertaining.",
      "link": "",
      "alt_text": "Living room and kitchen area of an apartment with a sofa, TV, and breakfast bar.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_185df098-478f-4bb4-82c0-a34751aabc29",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70a9-8fdb-773c-97d5-c0d758e2d888.webp",
      "image_media": {
        "alt_text": "Dining area with a round table, four chairs, and large windows with blue curtains.",
        "public_id": "019f70a9-8fdb-773c-97d5-c0d758e2d888",
        "storage_key": "property/6767906449165589/019f70a9-8fdb-773c-97d5-c0d758e2d888.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy meals in this bright dining area, perfect for intimate gatherings, featuring a round table and chairs with large windows for ample natural light.",
      "link": "",
      "alt_text": "Dining area with a round table, four chairs, and large windows with blue curtains.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7f70c26c-8f1d-43e9-9bf5-81a19e0f46c1",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019f70a9-2339-749d-a624-04e0d59abbb1.webp",
      "image_media": {
        "alt_text": "A beautifully decorated bedroom with a queen-size bed, dresser, and nightstand.",
        "public_id": "019f70a9-2339-749d-a624-04e0d59abbb1",
        "storage_key": "property/6767906449165589/019f70a9-2339-749d-a624-04e0d59abbb1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Discover comfort and style in this inviting bedroom, featuring a plush queen-size bed, elegant dresser, and a convenient nightstand. Perfect for relaxation.",
      "link": "",
      "alt_text": "A beautifully decorated bedroom with a queen-size bed, dresser, and nightstand.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_5f366309-e57b-494a-8ef4-a6c0fa6759f2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain steakhouse known for its hand-cut steaks, ribs, and made-from-scratch sides.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and filet medallions, and their rolls with cinnamon butter are a highlight. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ca01-712c-be1f-1f5fc4a4f4a3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ca01-712c-be1f-1f5fc4a4f4a3",
        "storage_key": "property/6767906449165589/019cfb3a-ca01-712c-be1f-1f5fc4a4f4a3.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "2.9",
      "poi_walking_minutes": "1 hour 4 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd7c-761c-82a9-46c08e859589",
        "storage_key": "property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_62d73868-8a75-41b7-b74e-f5b78796cb99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a diverse menu with delicious pasta, burgers, and cheesecake. They also highlight the attentive and friendly service, and the warm and welcoming atmosphere, ideal for a casual yet elevated evening out.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-caff-75d8-a8c3-9c0dff27979f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-caff-75d8-a8c3-9c0dff27979f",
        "storage_key": "property/6767906449165589/019cfb3a-caff-75d8-a8c3-9c0dff27979f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd7c-761c-82a9-46c08e859589",
        "storage_key": "property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_41a10eff-f80a-4b34-a4aa-3383ff0ec661",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Casual chain, known for battered chicken fingers, fries, Texas toast and signature sauce, as well as friendly service.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers and a tasty dipping sauce. They highlight the fair pricing and generous portions. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-c95e-7639-abac-6fec0012a7d8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-c95e-7639-abac-6fec0012a7d8",
        "storage_key": "property/6767906449165589/019cfb3a-c95e-7639-abac-6fec0012a7d8.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 4 mins",
      "poi_biking_minutes": "48 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd7c-761c-82a9-46c08e859589",
        "storage_key": "property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_5854f5c8-3f4c-4e1a-b800-db1647257b20",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly national chain serving classic American comfort foods, plus cocktails, beer and steaks.",
      "poi_long_description": "Diners say this traditional US American restaurant serves up delicious honey butter croissants, salmon, and steak. They also highlight the friendly and attentive service, reasonable prices, and generous portions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-c9dd-727f-9b9d-916aeab4b75e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-c9dd-727f-9b9d-916aeab4b75e",
        "storage_key": "property/6767906449165589/019cfb3a-c9dd-727f-9b9d-916aeab4b75e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd7c-761c-82a9-46c08e859589",
        "storage_key": "property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_5c24aa2d-d933-420f-989a-5665c6a761e9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Tulsa Incredible Pizza Company",
      "poi_type": "Restaurants",
      "poi_address": "8314 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Buffet, pizza and game chain featuring bumper cars and laser-tag attractions.",
      "poi_long_description": "People say this pizza restaurant offers a buffet with a wide variety of options, including pizza, hot dogs, fried chicken, and desserts, as well as rides, games, and attractions like go-karts and laser tag. They also highlight the fun experience, the friendly staff, and the good value for the price.\n\nOther reviews mention the games can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-c9ed-7249-b843-78e5e8644cde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-c9ed-7249-b843-78e5e8644cde",
        "storage_key": "property/6767906449165589/019cfb3a-c9ed-7249-b843-78e5e8644cde.webp",
        "width": 502,
        "height": 270
      },
      "poi_business_url": "https://incrediblepizza.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16906715592224650215&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-incredible-pizza-company",
      "poi_latitude": "36.0589793",
      "poi_longitude": "-95.8832543",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-294-8671",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd7c-761c-82a9-46c08e859589",
        "storage_key": "property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJidT2-ZONtocR57MbaUG4oOo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_80f64777-e166-4950-bf9a-ea648c34eb62",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Spacious, clean, 2-level shopping center featuring a carousel for kids as well as a variety of food options.",
      "poi_long_description": "Visitors say this shopping center has a wide variety of stores, including Scheels, Macy's, Dillard's, and JCPenney, and a great food court with many options. They also highlight the clean, safe, and friendly atmosphere, and the family-friendly environment with activities for children.\n\nSome reviews mention the escalators can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-c9d5-73a6-a512-e734c998106f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-c9d5-73a6-a512-e734c998106f",
        "storage_key": "property/6767906449165589/019cfb3a-c9d5-73a6-a512-e734c998106f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8a-753d-8d49-80449c9470a3",
        "storage_key": "property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_6744300c-bc4c-42c6-90a8-4130512a0264",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Tulsa Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 E Outlet Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Clean outdoor mall offering discounts on designer wares and home goods, plus a playground.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores with great deals and discounts. They highlight the clean, spacious, and welcoming atmosphere, as well as the convenient layout and ample parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-cae8-7583-bcdb-8e0c56592260.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-cae8-7583-bcdb-8e0c56592260",
        "storage_key": "property/6767906449165589/019cfb3a-cae8-7583-bcdb-8e0c56592260.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542502898214519848&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-premium-outlets",
      "poi_latitude": "36.0147952",
      "poi_longitude": "-95.962744",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-528-8940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8a-753d-8d49-80449c9470a3",
        "storage_key": "property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi_O0gRORtocRKERWF3F9c_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_16e0c4ab-f59d-42d9-8dc5-674baacc642b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Food mart stocking meat, baked goods and household staples, plus bulk bins.",
      "poi_long_description": "Shoppers say this grocery store offers great savings on a wide variety of items, including bulk goods like candy, nuts, and spices, as well as fresh produce and quality meats. They also highlight the store's 24/7 accessibility, reasonable prices, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ca11-7240-9552-d9e850f7eddc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ca11-7240-9552-d9e850f7eddc",
        "storage_key": "property/6767906449165589/019cfb3a-ca11-7240-9552-d9e850f7eddc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ddba-77e9-b52c-6345c11174b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ddba-77e9-b52c-6345c11174b6",
        "storage_key": "property/6767906449165589/019cfb3a-ddba-77e9-b52c-6345c11174b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_5cadcbfd-d8c4-4ed2-b96e-3b8c5a7a59d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, live seafood, and Asian groceries, including a large selection of meats, spices, and noodles. They highlight the fair prices, the clean and organized store, and the delicious hot food, boba tea, and sushi available at the cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ca03-7179-aace-c9fa38190428.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ca03-7179-aace-c9fa38190428",
        "storage_key": "property/6767906449165589/019cfb3a-ca03-7179-aace-c9fa38190428.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ddba-77e9-b52c-6345c11174b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ddba-77e9-b52c-6345c11174b6",
        "storage_key": "property/6767906449165589/019cfb3a-ddba-77e9-b52c-6345c11174b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_25baa14a-6d8e-4d87-bf54-92b35dc600a0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9136 S Yale Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Market selling organic produce and gluten-free grocery items.",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy and organic foods, including fresh produce, a salad bar, and a variety of vitamins and supplements. They also highlight the clean and organized layout, the friendly and helpful staff, and the relaxed shopping experience.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-c9dd-727f-9b9d-8d9f02b9b887.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-c9dd-727f-9b9d-8d9f02b9b887",
        "storage_key": "property/6767906449165589/019cfb3a-c9dd-727f-9b9d-8d9f02b9b887.webp",
        "width": 1280,
        "height": 603
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/yale?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690334156598386947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "36.030638",
      "poi_longitude": "-95.9237179",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-879-0493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ddba-77e9-b52c-6345c11174b6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ddba-77e9-b52c-6345c11174b6",
        "storage_key": "property/6767906449165589/019cfb3a-ddba-77e9-b52c-6345c11174b6.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2KYkCCStocRA6HtoRBqF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e14d0f29-280c-477b-9fbd-5204d9b295bd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-cd6c-710b-888d-0689e89be0a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-cd6c-710b-888d-0689e89be0a0",
        "storage_key": "property/6767906449165589/019cfb3a-cd6c-710b-888d-0689e89be0a0.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "51 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ddb3-705a-8a5f-ef151229663a",
        "storage_key": "property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_8cbd5ab0-a0e3-4c93-89ad-55066ee90598",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ce66-708c-859e-0238898e84f6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ce66-708c-859e-0238898e84f6",
        "storage_key": "property/6767906449165589/019cfb3a-ce66-708c-859e-0238898e84f6.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ddb3-705a-8a5f-ef151229663a",
        "storage_key": "property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_b85fd56a-06a9-4d80-9ab2-8bea76f85d12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide selection of books, study rooms, and computers. They highlight the clean and safe environment, and the helpful staff. They also like the separate kids and adult sections, and the dedicated teen space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-cdd5-7178-90b3-21287cfb93df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-cdd5-7178-90b3-21287cfb93df",
        "storage_key": "property/6767906449165589/019cfb3a-cdd5-7178-90b3-21287cfb93df.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ddb3-705a-8a5f-ef151229663a",
        "storage_key": "property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_10ee5567-9138-4e86-abe5-a354282a5d2e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Northeastern State University Broken Arrow",
      "poi_type": "Education",
      "poi_address": "3100 New Orleans St, Broken Arrow, OK 74014, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ce5a-7397-bd91-3182a9914b42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ce5a-7397-bd91-3182a9914b42",
        "storage_key": "property/6767906449165589/019cfb3a-ce5a-7397-bd91-3182a9914b42.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://nsuok.edu/BrokenArrow.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=3996275873980647977&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "northeastern-state-university-broken-arrow",
      "poi_latitude": "36.019376",
      "poi_longitude": "-95.7485342",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 31 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-449-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ddb3-705a-8a5f-ef151229663a",
        "storage_key": "property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6bWtJw_7yYcRKYoU9bufdTc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_36c6b406-dd80-4832-a8a4-5cb1f0942d52",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "TCC Southeast Library",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St Building 7, Room 7200, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ce98-74ff-86ef-c5e497b916fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ce98-74ff-86ef-c5e497b916fd",
        "storage_key": "property/6767906449165589/019cfb3a-ce98-74ff-86ef-c5e497b916fd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://library.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10341227726380407188&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tcc-southeast-library",
      "poi_latitude": "36.0433144",
      "poi_longitude": "-95.8632335",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-595-7701",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd99-77ef-b6bf-85f81becb9e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd99-77ef-b6bf-85f81becb9e8",
        "storage_key": "property/6767906449165589/019cfb3a-dd99-77ef-b6bf-85f81becb9e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhdNrW1mNtocRlBlTtNNrg48",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_d4ed7d72-521e-4db5-8a0e-919958d185c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Relaxed aquarium with sharks, river otters, turtles and jellyfish.",
      "poi_long_description": "People say this aquarium offers a wide variety of fish, including sharks, jellyfish, and an octopus, as well as interactive exhibits and touch tanks. They highlight the family-friendly atmosphere, the fun and educational experience, and the impressive shark tunnel and sea turtle exhibit. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ce99-77ae-9f04-cb1083fef8d3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ce99-77ae-9f04-cb1083fef8d3",
        "storage_key": "property/6767906449165589/019cfb3a-ce99-77ae-9f04-cb1083fef8d3.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 36 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_b972c988-48eb-4137-902b-1cf544c7f7e2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Sprawling facility for concerts, basketball events and graduations, plus other events.",
      "poi_long_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ce8c-7656-9a0d-aea8ad0a8230.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ce8c-7656-9a0d-aea8ad0a8230",
        "storage_key": "property/6767906449165589/019cfb3a-ce8c-7656-9a0d-aea8ad0a8230.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_111ca009-6588-4986-af13-49fc224938d5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "8306 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Gravity-defying entertainment venue with state-of-the-art trampolines, plus dodgeball courts.",
      "poi_long_description": "People say this amusement park offers fun trampolines, attractions, and a zip line. They also highlight the massage chairs for adults and the designated space for birthday parties.\n\nOther reviews mention the customer service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ceb3-757d-952e-94e1a8f61e18.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ceb3-757d-952e-94e1a8f61e18",
        "storage_key": "property/6767906449165589/019cfb3a-ceb3-757d-952e-94e1a8f61e18.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://www.skyzone.com/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967499010622421820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "36.07405900000001",
      "poi_longitude": "-95.883873",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-877-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3PGwZ2NtocRPPt4r6CsLik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_d8b794ed-5d02-4822-9819-5cef4a5e7792",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "5352 E Skelly Dr, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun slides, a basketball court, and a play area for younger children. They also highlight the friendly and helpful staff, and the clean and safe environment.\n\nOther reviews mention the concessions can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-cf24-77fa-98f3-464128e8f28c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-cf24-77fa-98f3-464128e8f28c",
        "storage_key": "property/6767906449165589/019cfb3a-cf24-77fa-98f3-464128e8f28c.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/ok-tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12324602171454774354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "36.0979811",
      "poi_longitude": "-95.9157069",
      "poi_miles_from_property": "8.5",
      "poi_walking_minutes": "3 hours 10 mins",
      "poi_biking_minutes": "49 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-818-7423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFytTvJWTtocRUtyRW2DICas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_21eba958-c83a-40a5-8520-efcc7bf4deef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Tiger Memorial Stadium",
      "poi_type": "Entertainment",
      "poi_address": "1901 E Albany St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d013-720e-b49c-3f31e7e4084e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d013-720e-b49c-3f31e7e4084e",
        "storage_key": "property/6767906449165589/019cfb3a-d013-720e-b49c-3f31e7e4084e.webp",
        "width": 1280,
        "height": 640
      },
      "poi_business_url": "https://batigersports.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6374532252761582339&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tiger-memorial-stadium",
      "poi_latitude": "36.0743308",
      "poi_longitude": "-95.7632923",
      "poi_miles_from_property": "8.2",
      "poi_walking_minutes": "3 hours 1 min",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 918-259-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd98-771a-a55f-489c294cb8c8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd98-771a-a55f-489c294cb8c8",
        "storage_key": "property/6767906449165589/019cfb3a-dd98-771a-a55f-489c294cb8c8.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ6SOplVCKtocRA-sfZ0_jdlg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "stadium"
    },
    {
      "id": "custom_9cfd7d4c-6cbd-44f3-b143-abcd284a78f5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d12e-70ef-8909-4ab3dd6ba1da.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d12e-70ef-8909-4ab3dd6ba1da",
        "storage_key": "property/6767906449165589/019cfb3a-d12e-70ef-8909-4ab3dd6ba1da.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_14ad855b-6f2a-43e4-b985-ee04de49e662",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group classes, and has a clean facility with helpful and knowledgeable staff.\n\nOther reviews mention the membership cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d170-7467-849d-1a1f7c15e94d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d170-7467-849d-1a1f7c15e94d",
        "storage_key": "property/6767906449165589/019cfb3a-d170-7467-849d-1a1f7c15e94d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 0 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_1fbf1de1-c626-4320-855e-6e6841995936",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d25d-76cb-93ee-e3bc68c6b2f8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d25d-76cb-93ee-e3bc68c6b2f8",
        "storage_key": "property/6767906449165589/019cfb3a-d25d-76cb-93ee-e3bc68c6b2f8.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_28b90483-efe9-495c-8aac-3b42b90a011e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8405 E 91st Pl, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed, chain gym featuring free weights, massage chairs and tanning beds, plus classes.",
      "poi_long_description": "Gym goers say this gym offers a clean and tidy facility with a welcoming and judgement-free atmosphere, and they appreciate the friendly and helpful staff. They also highlight the great price and smooth interaction with other members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d286-7562-a5ec-f160706f1624.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d286-7562-a5ec-f160706f1624",
        "storage_key": "property/6767906449165589/019cfb3a-d286-7562-a5ec-f160706f1624.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-tulsa-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=294788399712763127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0326146",
      "poi_longitude": "-95.8832595",
      "poi_miles_from_property": "2.3",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 539-664-7592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu58mAgqOtocR9_zI2HxMFwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0a3714d2-573d-4a8c-92c7-1e41a7479397",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "1800 S Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain fitness center featuring an indoor pool, walking track, and sauna, plus group classes.",
      "poi_long_description": "People say this gym offers a wide variety of machines, a pool, a sauna, and a steam room. They highlight the affordable membership price and the motivating, friendly, and clean environment. They also like the personable and caring staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d2a2-7583-8860-4b6cb8221d59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d2a2-7583-8860-4b6cb8221d59",
        "storage_key": "property/6767906449165589/019cfb3a-d2a2-7583-8860-4b6cb8221d59.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10gym.com/broken-arrow-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11720724796821001426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.0335826",
      "poi_longitude": "-95.8157827",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-251-4855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOe0w-qqOtocR0tSgiBphqKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_9953303e-ac31-4258-828b-5932584d2f40",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Ulta Beauty",
      "poi_type": "Health and Wellness",
      "poi_address": "8722 E 71st St Suite 872, Tulsa, OK 74133, USA",
      "poi_short_description": "Chains such as this one sell cosmetics, fragrances and makeup in stores and online, plus salon services.",
      "poi_long_description": "Chain with a diverse selection of cosmetics & other beauty products, plus on-site salon services.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d2a7-707e-bbe7-e260fcf3f868.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d2a7-707e-bbe7-e260fcf3f868",
        "storage_key": "property/6767906449165589/019cfb3a-d2a7-707e-bbe7-e260fcf3f868.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ulta.com/stores/tulsa-ok-1113",
      "poi_directions_map_url": "https://maps.google.com/?cid=9163598623872888103&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ulta-beauty",
      "poi_latitude": "36.059026",
      "poi_longitude": "-95.8790444",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-250-9053",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqUwgJEyMtocRJ60zyGWkK38",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hair_salon"
    },
    {
      "id": "custom_f93ba566-4bc3-4110-b377-94a3ceceb258",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Umac Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "6836 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Gym featuring basketball and volleyball courts, plus facilities for wrestling, cheerleading, and other competitions.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d315-71a8-a24b-a558e08bb89d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d315-71a8-a24b-a558e08bb89d",
        "storage_key": "property/6767906449165589/019cfb3a-d315-71a8-a24b-a558e08bb89d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.unionps.org/activities/umac",
      "poi_directions_map_url": "https://maps.google.com/?cid=17233318345147314712&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "umac-tulsa",
      "poi_latitude": "36.0641918",
      "poi_longitude": "-95.8694283",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 24 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-357-7480",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo05n3rqNtocRGHK6l7oLKe8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6098bce5-1deb-44f0-8338-15bc5eaa525a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "VASA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "7990 E 51st St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this gym offers a wide variety of fitness and yoga classes, as well as personal training. They also highlight the knowledgeable, supportive, and welcoming instructors, and the motivating atmosphere.\n\nOther reviews mention the facilities can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d3bf-70a6-b9ab-9addca93be81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d3bf-70a6-b9ab-9addca93be81",
        "storage_key": "property/6767906449165589/019cfb3a-d3bf-70a6-b9ab-9addca93be81.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://vasafitness.com/locations/ok/tulsa/?utm_medium=organic&utm_source=GMBlisting&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=11684131092404226149&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "vasa-fitness",
      "poi_latitude": "36.0885483",
      "poi_longitude": "-95.8878289",
      "poi_miles_from_property": "6.4",
      "poi_walking_minutes": "2 hours 22 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-984-1044",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhXRVgW-NtocRZcjZx1JfJqI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_aa6eacc6-d35c-46e0-a870-053df54b5d6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d3f8-742f-a87a-470d5b37cc42.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d3f8-742f-a87a-470d5b37cc42",
        "storage_key": "property/6767906449165589/019cfb3a-d3f8-742f-a87a-470d5b37cc42.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "6.8",
      "poi_walking_minutes": "2 hours 32 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8f-773c-8e04-e932a3ace29e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8f-773c-8e04-e932a3ace29e",
        "storage_key": "property/6767906449165589/019cfb3a-dd8f-773c-8e04-e932a3ace29e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_38b0cc10-6a75-480d-8a06-5904da8a0abf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Hillcrest South",
      "poi_type": "Health and Wellness",
      "poi_address": "8801 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d50b-7266-988b-bf8903793e9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d50b-7266-988b-bf8903793e9a",
        "storage_key": "property/6767906449165589/019cfb3a-d50b-7266-988b-bf8903793e9a.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "https://hillcrest.com/find-a-provider/location/hillcrestsouth8801s101steave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4505690926352009573&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillcrest-south",
      "poi_latitude": "36.0354556",
      "poi_longitude": "-95.8635828",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-294-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8f-773c-8e04-e932a3ace29e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8f-773c-8e04-e932a3ace29e",
        "storage_key": "property/6767906449165589/019cfb3a-dd8f-773c-8e04-e932a3ace29e.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-fcY9aNtocRZYnpfAZuhz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_8d0bbc26-fc9e-47a2-9252-367168d187d3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful display of Christmas lights, with a light show synchronized to music. They highlight the festive and family-friendly atmosphere, and the opportunity to walk or drive through the light experience. They also like the availability of hot cocoa, popcorn, and horse-drawn carriage rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d59a-74ad-b1b5-9e9fe5b17fbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d59a-74ad-b1b5-9e9fe5b17fbb",
        "storage_key": "property/6767906449165589/019cfb3a-d59a-74ad-b1b5-9e9fe5b17fbb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "4.9",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd94-776a-9c7c-9ee46f8d66e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd94-776a-9c7c-9ee46f8d66e3",
        "storage_key": "property/6767906449165589/019cfb3a-dd94-776a-9c7c-9ee46f8d66e3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_fd36f337-7cfb-45fd-90ec-b64874bae396",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including slides, swings, and a zipline, as well as picnic tables, soccer fields, and a water fountain with a bottle refill station. They highlight the park's clean bathrooms, shaded seating areas, and fenced-in playground, making it safe and enjoyable for children of all ages. They also like the park's accessible layout and thoughtful design, especially for toddlers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d64f-722c-a2a0-553232d51f62.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d64f-722c-a2a0-553232d51f62",
        "storage_key": "property/6767906449165589/019cfb3a-d64f-722c-a2a0-553232d51f62.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd94-776a-9c7c-9ee46f8d66e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd94-776a-9c7c-9ee46f8d66e3",
        "storage_key": "property/6767906449165589/019cfb3a-dd94-776a-9c7c-9ee46f8d66e3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_949a54d2-62ce-4deb-bdc8-f4f5b146b9d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Vast park, with playground areas, golf options, tennis courts, a pool and a community center.",
      "poi_long_description": "People say this park offers a golf course, playgrounds, walking trails, and picnic areas with grills. They highlight the park is clean, well-maintained, and safe, with plenty of parking and covered pavilions. They also like the wide walkways and the peaceful, quiet atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d677-764a-9b81-5bb35066a99e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d677-764a-9b81-5bb35066a99e",
        "storage_key": "property/6767906449165589/019cfb3a-d677-764a-9b81-5bb35066a99e.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "7.2",
      "poi_walking_minutes": "2 hours 41 mins",
      "poi_biking_minutes": "41 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd94-776a-9c7c-9ee46f8d66e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd94-776a-9c7c-9ee46f8d66e3",
        "storage_key": "property/6767906449165589/019cfb3a-dd94-776a-9c7c-9ee46f8d66e3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bfc98376-3149-462a-a4ea-d8cbf284d36a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Well-maintained park featuring a playground for kids and a dog park for pets, plus a splash pad and a pond for fishing.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d698-714d-a0c2-4d26ff80c029.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d698-714d-a0c2-4d26ff80c029",
        "storage_key": "property/6767906449165589/019cfb3a-d698-714d-a0c2-4d26ff80c029.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd94-776a-9c7c-9ee46f8d66e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd94-776a-9c7c-9ee46f8d66e3",
        "storage_key": "property/6767906449165589/019cfb3a-dd94-776a-9c7c-9ee46f8d66e3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bdf1fea0-6d28-4e26-9f24-89d6acf17287",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Calm park featuring frisbee golf, disc golf, swings and a playground for kids.",
      "poi_long_description": "People say this park offers a disc golf course, multiple playgrounds, walking trails, and picnic areas. They highlight the park is large, well-maintained, and has plenty of shaded areas. They also like the clean pavilions, volleyball, horseshoes, and open spaces for various activities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d6bb-7391-99f1-152443c2bcb6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d6bb-7391-99f1-152443c2bcb6",
        "storage_key": "property/6767906449165589/019cfb3a-d6bb-7391-99f1-152443c2bcb6.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd94-776a-9c7c-9ee46f8d66e3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd94-776a-9c7c-9ee46f8d66e3",
        "storage_key": "property/6767906449165589/019cfb3a-dd94-776a-9c7c-9ee46f8d66e3.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_814cd7e1-5b35-4d14-acd6-16832d8e1f54",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d761-77ce-b83a-0945af8d8c27.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d761-77ce-b83a-0945af8d8c27",
        "storage_key": "property/6767906449165589/019cfb3a-d761-77ce-b83a-0945af8d8c27.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1d8dee90-fc9f-4a79-9fc7-881a5a04d713",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d75e-704f-a0d0-800fd54fb508.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d75e-704f-a0d0-800fd54fb508",
        "storage_key": "property/6767906449165589/019cfb3a-d75e-704f-a0d0-800fd54fb508.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_9b7aa548-c9b6-4999-abba-32cd475dd7f7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d7a6-7361-a054-1f211b125070.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d7a6-7361-a054-1f211b125070",
        "storage_key": "property/6767906449165589/019cfb3a-d7a6-7361-a054-1f211b125070.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "5.7",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_a6e1d3e5-a81c-4eef-b17d-b8953934853b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d7d5-753f-a71c-5b84faea79ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d7d5-753f-a71c-5b84faea79ef",
        "storage_key": "property/6767906449165589/019cfb3a-d7d5-753f-a71c-5b84faea79ef.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_d3f551ad-e243-461b-96d1-7fa62f5323b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "City of Broken Arrow",
      "poi_type": "Major Employers & Offices",
      "poi_address": "220 S 1st St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-d969-777d-9e71-a00229794b0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019cfb3a-d969-777d-9e71-a00229794b0d",
        "storage_key": "property/6767906449165589/019cfb3a-d969-777d-9e71-a00229794b0d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.brokenarrowok.gov/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11981682047998685423&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "city-of-broken-arrow",
      "poi_latitude": "36.0510555",
      "poi_longitude": "-95.7899817",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd99-77ef-b6bf-85f81becb9e8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd99-77ef-b6bf-85f81becb9e8",
        "storage_key": "property/6767906449165589/019cfb3a-dd99-77ef-b6bf-85f81becb9e8.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmQP1vMOLtocR7_CiSld8R6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_hall"
    },
    {
      "id": "custom_bd9b1afe-c2da-4902-8d20-9cdea4935e98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Union Eighth Grade Center",
      "poi_type": "Education",
      "poi_address": "6501 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-bde7-70e4-9310-c9a4d8b92ad1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-bde7-70e4-9310-c9a4d8b92ad1",
        "storage_key": "property/6767906449165589/019d7911-bde7-70e4-9310-c9a4d8b92ad1.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8773159022692442711&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-eighth-grade-center",
      "poi_latitude": "36.0671931",
      "poi_longitude": "-95.8503859",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-357-4325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ddb3-705a-8a5f-ef151229663a",
        "storage_key": "property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJwUczVGMtocRV6KYIaaFwHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_13e0f607-fa36-40fe-81d6-b08cf401afee",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-bea8-7449-9005-02f964fa7012.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-bea8-7449-9005-02f964fa7012",
        "storage_key": "property/6767906449165589/019d7911-bea8-7449-9005-02f964fa7012.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "13.4 mi",
      "poi_walking_minutes": "4 hours 59 mins",
      "poi_biking_minutes": "1 hour 39 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ddb3-705a-8a5f-ef151229663a",
        "storage_key": "property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_af284825-3ef8-41fa-8672-9ca4b4cc927d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Cedar Ridge Elementary School",
      "poi_type": "Education",
      "poi_address": "9817 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-c549-712e-a8f4-f2374e8fd46e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c549-712e-a8f4-f2374e8fd46e",
        "storage_key": "property/6767906449165589/019d7911-c549-712e-a8f4-f2374e8fd46e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://cedarridge.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7739981988625288061&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cedar-ridge-elementary-school",
      "poi_latitude": "36.0219642",
      "poi_longitude": "-95.8673969",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "25 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-357-4331",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ddb3-705a-8a5f-ef151229663a",
        "storage_key": "property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJq3IV_G-OtocRfYvuR5zwaWs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_3b4ed6f1-ab6b-4a83-8abb-035c2e5558f4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Union High School",
      "poi_type": "Education",
      "poi_address": "6636 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-be9d-731f-bc75-42a9ca837c1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-be9d-731f-bc75-42a9ca837c1b",
        "storage_key": "property/6767906449165589/019d7911-be9d-731f-bc75-42a9ca837c1b.webp",
        "width": 1000,
        "height": 700
      },
      "poi_business_url": "https://www.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2856521135297069003&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-high-school",
      "poi_latitude": "36.0666635",
      "poi_longitude": "-95.8701703",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-357-4323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-ddb3-705a-8a5f-ef151229663a",
        "storage_key": "property/6767906449165589/019cfb3a-ddb3-705a-8a5f-ef151229663a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB7WuyaSNtocRy__GitZmpCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_5ead775e-021b-43a1-8eff-d34e2b33b02f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "The Big Biscuit",
      "poi_type": "Restaurants",
      "poi_address": "8920 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual cafe serving pancakes and waffles for breakfast, lunch and brunch, with biscuits also on the menu.",
      "poi_long_description": "People say this breakfast restaurant serves delicious biscuits, biscuits and gravy, chicken fried steak, and waffles. They highlight the large portions, quick service, and attentive staff. They also like the friendly staff and inviting atmosphere.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-c992-710b-9cea-2c02ce2f529a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c992-710b-9cea-2c02ce2f529a",
        "storage_key": "property/6767906449165589/019d7911-c992-710b-9cea-2c02ce2f529a.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://bigbiscuit.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15812448215389890625&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-big-biscuit",
      "poi_latitude": "36.0337674",
      "poi_longitude": "-95.8872532",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-957-5163",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd7c-761c-82a9-46c08e859589",
        "storage_key": "property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJDXbuOl2NtocRQeiSu98Zcds",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "breakfast_restaurant"
    },
    {
      "id": "custom_1b738e79-b5c0-4479-9414-5608d9c7d471",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "10121 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "People say this fast food restaurant serves delicious burgers and fries.\n\nOther reviews mention the drive-thru can be slow and orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-cb14-738b-8d17-a8adc9fc6f81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-cb14-738b-8d17-a8adc9fc6f81",
        "storage_key": "property/6767906449165589/019d7911-cb14-738b-8d17-a8adc9fc6f81.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://locations.whataburger.com/ok/tulsa/10121-s-memorial-dr.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=10228918417140668012&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "36.0156688",
      "poi_longitude": "-95.8857333",
      "poi_miles_from_property": "2.5 mi",
      "poi_walking_minutes": "56 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-878-8202",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd7c-761c-82a9-46c08e859589",
        "storage_key": "property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUU3FyxCOtocRbNYe8hpr9I0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_80fff119-e631-4377-9a19-cc13e100bfec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Mazzio's",
      "poi_type": "Restaurants",
      "poi_address": "101 E 81st St S, Tulsa, OK 74132, USA",
      "poi_short_description": "Family-friendly chain featuring pizzas, pastas, salads & subs, with a weekday lunch buffet.",
      "poi_long_description": "Family-friendly chain featuring pizzas, pastas, salads & subs, with a weekday lunch buffet.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.mazzios.com/find-a-mazzios/?address%5B0%5D&post%5B0%5D=locations&tax%5Brestaurant_features%5D%5B0%5D&distance=25&units=imperial&per_page=200&lat&lng&form=3",
      "poi_directions_map_url": "https://maps.google.com/?cid=7566912927744272082&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "mazzio-s",
      "poi_latitude": "36.0520264",
      "poi_longitude": "-95.9883046",
      "poi_miles_from_property": "9.9 mi",
      "poi_walking_minutes": "3 hours 39 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-629-9467",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd7c-761c-82a9-46c08e859589",
        "storage_key": "property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJCenCeXSUtocR0iaCcDcTA2k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_f48050fa-dac0-4c81-89ad-d3e5427d64f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Sunrise Cafe",
      "poi_type": "Restaurants",
      "poi_address": "6514 E 101st St S # A, Tulsa, OK 74133, USA",
      "poi_short_description": "Bright, inviting restaurant in the Village South Shopping Center serving breakfast, brunch, and lunch.",
      "poi_long_description": "People say this restaurant serves delicious breakfast and brunch dishes, including pancakes, omelets, and breakfast bowls. They highlight the generous portions, affordable prices, and chill, family-friendly atmosphere. They also like the friendly and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-d64b-76b2-b7ca-abdd091a8ad2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d64b-76b2-b7ca-abdd091a8ad2",
        "storage_key": "property/6767906449165589/019d7911-d64b-76b2-b7ca-abdd091a8ad2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.sunrisecafetulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15436643819048298963&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sunrise-cafe",
      "poi_latitude": "36.0168344",
      "poi_longitude": "-95.9030274",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-600-0950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd7c-761c-82a9-46c08e859589",
        "storage_key": "property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJYXxAQNORtocR02maPsT5OdY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_8c73e7fe-0827-4039-b13e-3866f388c2ef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Slim Chickens",
      "poi_type": "Restaurants",
      "poi_address": "11012 E 81st St S, Tulsa, OK 74133, USA",
      "poi_short_description": "Counter-serve chain specializing in chicken dishes, plus Southern sides & desserts served in jars.",
      "poi_long_description": "People say this chicken restaurant serves delicious chicken strips, bone-in wings, and fries with a variety of sauces. They also highlight the reasonable prices, clean facilities, and friendly staff.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-dabd-74e9-8b79-5df83b8d791a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-dabd-74e9-8b79-5df83b8d791a",
        "storage_key": "property/6767906449165589/019d7911-dabd-74e9-8b79-5df83b8d791a.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://slimchickens.com/?utm_source=google&utm_medium=organic&utm_campaign=gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=13683349092678509984&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "slim-chickens",
      "poi_latitude": "36.045917",
      "poi_longitude": "-95.852939",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 539-367-1001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd7c-761c-82a9-46c08e859589",
        "storage_key": "property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx_7Lq5yNtocRoCXEloAF5b0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chicken_restaurant"
    },
    {
      "id": "custom_c633a54b-333d-42dc-8776-dcb9ba197763",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Uncle Paco's Mexican Grill",
      "poi_type": "Restaurants",
      "poi_address": "8222 E 103rd St Ste 129, Tulsa, OK 74133, USA",
      "poi_short_description": "Upbeat, spacious restaurant offering a big menu of traditional Mexican plates & margaritas.",
      "poi_long_description": "People say this Mexican restaurant serves delicious tacos, fajitas, and birria, and offers a variety of combo meals and lunch specials. They highlight the large portions, fresh tortillas, and tasty white queso dip, and like the fun, festive atmosphere with soccer playing on TVs. They also mention the staff is friendly and attentive, and the service is fast.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-d7a1-7353-83d8-423bf4c9520a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d7a1-7353-83d8-423bf4c9520a",
        "storage_key": "property/6767906449165589/019d7911-d7a1-7353-83d8-423bf4c9520a.webp",
        "width": 1271,
        "height": 1280
      },
      "poi_business_url": "http://unclepacos.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12227180875079626345&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "uncle-paco-s-mexican-grill",
      "poi_latitude": "36.013417",
      "poi_longitude": "-95.8842107",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "59 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-943-5588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd7c-761c-82a9-46c08e859589",
        "storage_key": "property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJn-ekdNOPtocRaS6SNzmsr6k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_b3622d3a-05a8-4a5b-8a65-ccb3f703de70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Tropical Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "8125 E 49th St, Tulsa, OK 74145, USA",
      "poi_short_description": "Family-friendly Thai restaurant focusing on seafood dishes made from farm-fresh ingredients.",
      "poi_long_description": "People say this Thai restaurant serves delicious green curry, fried rice, and calamari. They highlight the fresh ingredients, generous portions, and bold flavors. They also like the friendly staff and attentive service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-dd8e-730a-9896-539e1695167d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-dd8e-730a-9896-539e1695167d",
        "storage_key": "property/6767906449165589/019d7911-dd8e-730a-9896-539e1695167d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.tropicaltulsa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8206012777884877667&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "tropical-restaurant-bar",
      "poi_latitude": "36.0932212",
      "poi_longitude": "-95.8855814",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-895-6433",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd7c-761c-82a9-46c08e859589",
        "storage_key": "property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0RA4GiNtocRYwMl6CSd4XE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "thai_restaurant"
    },
    {
      "id": "custom_25e2819e-a310-4c59-a49f-978a4331bd46",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Society Burger",
      "poi_type": "Restaurants",
      "poi_address": "9999 S Mingo Rd Suite A, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual restaurant serving burgers and milkshakes, plus beer and other cocktails.",
      "poi_long_description": "People say this American restaurant serves delicious burgers, including bacon cheeseburgers and the PB and B, as well as salads like the Chopped Salad. They also highlight the attentive service and comfortable atmosphere.\n\nSome reviews mention the food can be cold.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-e4fc-714b-b2fe-769cd72103cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e4fc-714b-b2fe-769cd72103cd",
        "storage_key": "property/6767906449165589/019d7911-e4fc-714b-b2fe-769cd72103cd.webp",
        "width": 1280,
        "height": 598
      },
      "poi_business_url": "https://societyburger.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12971559044170636276&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "society-burger",
      "poi_latitude": "36.0187754",
      "poi_longitude": "-95.8680649",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-615-6970",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd7c-761c-82a9-46c08e859589",
        "storage_key": "property/6767906449165589/019cfb3a-dd7c-761c-82a9-46c08e859589.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJRVy7B8OPtocR9NvLcjk8BLQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_efa94e2c-1950-4474-aa3f-0d688c3e520e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Lowe's Home Improvement",
      "poi_type": "Shopping & Retail",
      "poi_address": "10156 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Home improvement chain for appliances & gardening supplies, plus tools & hardware.",
      "poi_long_description": "People say this home improvement store offers a huge selection of products at competitive prices, and they appreciate the helpful, knowledgeable staff. They also highlight the friendly and efficient customer service, making for a pleasant shopping experience.\n\nSome reviews mention the staff can be difficult to find.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-e9f2-767b-b1c3-81afcac483b3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e9f2-767b-b1c3-81afcac483b3",
        "storage_key": "property/6767906449165589/019d7911-e9f2-767b-b1c3-81afcac483b3.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.lowes.com/store/OK-Tulsa/0243?cm_mmc=lod-_-c-_-lcl-_-awr-_-yxt-_-go-_-243-_-na-_-0-_-0&y_source=1_MTE4NDQwMS03MTUtbG9jYXRpb24ud2Vic2l0ZQ%3D%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=6856323657873291907&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "lowe-s-home-improvement",
      "poi_latitude": "36.058601",
      "poi_longitude": "-95.862348",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-459-9922",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8a-753d-8d49-80449c9470a3",
        "storage_key": "property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ25byKLGNtocRg_qkXAqOJl8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_4f4d8a44-aa63-400b-8f50-4c00306a9734",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Academy Sports + Outdoors",
      "poi_type": "Shopping & Retail",
      "poi_address": "7850 S 107th E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_long_description": "Shoppers say this sporting goods store offers a wide selection of shoes, camping equipment, and fishing gear, with great deals and fair prices. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nSome reviews mention the online shopping experience can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-ed41-71b3-ae2b-3d2bdccb6593.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-ed41-71b3-ae2b-3d2bdccb6593",
        "storage_key": "property/6767906449165589/019d7911-ed41-71b3-ae2b-3d2bdccb6593.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.academy.com/storelocator/oklahoma/tulsa/store-0084",
      "poi_directions_map_url": "https://maps.google.com/?cid=13160923161417580787&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "academy-sports-outdoors",
      "poi_latitude": "36.0493635",
      "poi_longitude": "-95.8561662",
      "poi_miles_from_property": "2.2 mi",
      "poi_walking_minutes": "48 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-249-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8a-753d-8d49-80449c9470a3",
        "storage_key": "property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ47lbY8uNtocR84CBwOL9pLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_a8031676-5b45-45fc-9a6d-6750e68c4d29",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "HomeGoods",
      "poi_type": "Shopping & Retail",
      "poi_address": "10122 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Home-decor chain stocking a variety of furnishings, bedding, kitchenware, holiday goods & more.",
      "poi_long_description": "People say this department store offers a wide variety of specialty foods, kitchen appliances, and home decor. They also highlight the great deals, unique finds, and fun shopping experience.\n\nSome reviews mention the aisles can be narrow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-f662-75f2-9c59-08e12e76a978.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f662-75f2-9c59-08e12e76a978",
        "storage_key": "property/6767906449165589/019d7911-f662-75f2-9c59-08e12e76a978.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.homegoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3972400949711173361&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "homegoods",
      "poi_latitude": "36.0161188",
      "poi_longitude": "-95.8885836",
      "poi_miles_from_property": "2.7 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-364-4770",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8a-753d-8d49-80449c9470a3",
        "storage_key": "property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOXYMBhqOtocR8Xb1-J3NIDc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_eea62200-1b4c-47ad-8120-6fb6b3b2752c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "10938 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Expansive multi-department store stocking clothing, home furnishings, toys and electronics plus groceries.",
      "poi_long_description": "People say this department store offers a wide variety of products and has a convenient layout. They also highlight the clean and organized environment, and the fair prices.\n\nOther reviews mention the service can be unhelpful.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-f2ff-720c-97e4-d082f729b915.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f2ff-720c-97e4-d082f729b915",
        "storage_key": "property/6767906449165589/019d7911-f2ff-720c-97e4-d082f729b915.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/1597-tulsa-ok/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=10170152242223552650&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "36.0046323",
      "poi_longitude": "-95.8894474",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-394-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8a-753d-8d49-80449c9470a3",
        "storage_key": "property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJewC1ajuOtocRiphgnZSjI40",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_1406371b-4a98-4860-a844-6ace07cb2cdb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Kohl's",
      "poi_type": "Shopping & Retail",
      "poi_address": "11011 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain department store offering a wide selection of clothing, accessories & homewares.",
      "poi_long_description": "Shoppers say this department store offers a wide selection of products, great sales, and good prices. They also highlight the friendly and helpful staff, and the clean and organized store.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-f64f-76e9-b8b5-953054f4dd56.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f64f-76e9-b8b5-953054f4dd56",
        "storage_key": "property/6767906449165589/019d7911-f64f-76e9-b8b5-953054f4dd56.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.kohls.com/stores/ok/tulsa-425.shtml?utm_source=google&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=10465943342793208862&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kohl-s",
      "poi_latitude": "36.0629677",
      "poi_longitude": "-95.8533535",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 6 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-461-1950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8a-753d-8d49-80449c9470a3",
        "storage_key": "property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJwxxHW0yMtocRHrSN8gSAPpE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_b7b9a579-86c4-40cd-bc6b-39c60812c0d2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Best Buy",
      "poi_type": "Shopping & Retail",
      "poi_address": "10303 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain retailer with a large array of brand-name electronics, computers, appliances & more.",
      "poi_long_description": "People say this electronics store offers a wide variety of products, including TVs, laptops, and appliances. They also highlight the knowledgeable and helpful staff, and the convenient online ordering and pick-up service.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-fd0c-72ed-b703-fadaa8083b7f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fd0c-72ed-b703-fadaa8083b7f",
        "storage_key": "property/6767906449165589/019d7911-fd0c-72ed-b703-fadaa8083b7f.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://stores.bestbuy.com/ok/tulsa/10303-e-71st-st-221.html/?ref=NS&loc=ns100",
      "poi_directions_map_url": "https://maps.google.com/?cid=2994601933184998961&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "best-buy",
      "poi_latitude": "36.064164",
      "poi_longitude": "-95.86075",
      "poi_miles_from_property": "3.6 mi",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-250-6819",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8a-753d-8d49-80449c9470a3",
        "storage_key": "property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ5SOWULGNtocRMZ4wl5f2jik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "electronics_store"
    },
    {
      "id": "custom_82b4f8f2-e4d8-4f58-a4c4-d74edf86f7c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Regal Warren Broken Arrow",
      "poi_type": "Entertainment",
      "poi_address": "1700 Aspen Creek Dr, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Retro-style multiplex chain showing new releases; some locations feature '40s-style diners & IMAX.",
      "poi_long_description": "People say this movie theater offers reclining seats, heated seats, and a balcony experience. They highlight the comfortable seating, clean facilities, and friendly staff. They also like the concessions, which include popcorn and adult beverages.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7911-fcc7-7173-86cb-7d768fe8221d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fcc7-7173-86cb-7d768fe8221d",
        "storage_key": "property/6767906449165589/019d7911-fcc7-7173-86cb-7d768fe8221d.webp",
        "width": 1280,
        "height": 948
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-warren-broken-arrow-1448?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6017797638634288047&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "regal-warren-broken-arrow",
      "poi_latitude": "35.9913186",
      "poi_longitude": "-95.8096298",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7912-1684-711e-8bae-c63fe0d634b4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-1684-711e-8bae-c63fe0d634b4",
        "storage_key": "property/6767906449165589/019d7912-1684-711e-8bae-c63fe0d634b4.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJg3CO8bGJtocRrzP7lBGDg1M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_af8b41dd-0e72-4fd7-a8e1-c4a9fcdd18af",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Cinergy's Extreme Escape Room - Tulsa",
      "poi_type": "Entertainment",
      "poi_address": "6808 S Memorial Dr Suite #300, Tulsa, OK 74133, USA",
      "poi_short_description": "Escape room center with ax throwing, bowling, and a bar, plus a movie theater.",
      "poi_long_description": "People say this escape room center offers a variety of escape rooms and an arcade. They also highlight the fun atmosphere and the opportunity to win prizes.\n\nSome reviews mention the escape rooms can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7912-0052-7201-b884-2a508b710782.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0052-7201-b884-2a508b710782",
        "storage_key": "property/6767906449165589/019d7912-0052-7201-b884-2a508b710782.webp",
        "width": 1200,
        "height": 786
      },
      "poi_business_url": "https://www.cinergy.com/escape-room/tulsa?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing-escape",
      "poi_directions_map_url": "https://maps.google.com/?cid=5180287137507824221&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinergy-s-extreme-escape-room-tulsa",
      "poi_latitude": "36.0640143",
      "poi_longitude": "-95.8890616",
      "poi_miles_from_property": "4.7 mi",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-894-6888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYRH29AyNtocRXdKtibQT5Ec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_c7a2f17e-db3e-4c24-9952-3b6e2dd3660a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Riverwalk Crossing",
      "poi_type": "Entertainment",
      "poi_address": "300 Riverwalk Terrace, Jenks, OK 74037, USA",
      "poi_short_description": "Lifestyle center on the Arkansas River and Muscogee (Creek) Nation reservation, with shopping, dining, live music, and a trail system.",
      "poi_long_description": "People say this shopping center offers a great selection of food and snacks, with many mentioning the Mexican grill. They also highlight the fun and peaceful atmosphere, beautiful scenery, and great service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7912-08a7-77a8-b22c-bee95167481d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-08a7-77a8-b22c-bee95167481d",
        "storage_key": "property/6767906449165589/019d7912-08a7-77a8-b22c-bee95167481d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.jenksriverwalk.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11784666382402635584&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "riverwalk-crossing",
      "poi_latitude": "36.0256838",
      "poi_longitude": "-95.95905820000002",
      "poi_miles_from_property": "6.6 mi",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-518-6675",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8a-753d-8d49-80449c9470a3",
        "storage_key": "property/6767906449165589/019cfb3a-dd8a-753d-8d49-80449c9470a3.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJu9Z8JGCRtocRQMeYD6OLi6M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_7bbcb742-d0d6-4b10-841c-64ae6e7c37fc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Cedar Ridge Country Club",
      "poi_type": "Entertainment",
      "poi_address": "10302 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Golf and dining venue offering regular business events and a pool.",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019d7912-0836-7139-a4d4-b7cc8ac29c15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-0836-7139-a4d4-b7cc8ac29c15",
        "storage_key": "property/6767906449165589/019d7912-0836-7139-a4d4-b7cc8ac29c15.webp",
        "width": 650,
        "height": 433
      },
      "poi_business_url": "http://www.crccok.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14277941534016940443&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cedar-ridge-country-club",
      "poi_latitude": "36.0133285",
      "poi_longitude": "-95.8529968",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-252-2501",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb3a-dd8d-7265-89bd-953344637d24",
        "storage_key": "property/6767906449165589/019cfb3a-dd8d-7265-89bd-953344637d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6VX0foyOtocRmyngai1wJcY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "association_or_organization"
    },
    {
      "id": "custom_8f7f3a66-5f1a-43fd-85f5-78944476bc60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Union 6/7 Center",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "union-6-7-center",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_36d33c1a-3681-42b3-bbb7-f0fe27955799",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Regent Preparatory School (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "regent-preparatory-school-grades-pre-k-through-12",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_86ad4d68-d405-4ee3-aadb-bb860cc698db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Holland Hall (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "holland-hall-grades-pre-k-through-12",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6898bc78-18fe-4fcb-99a5-ad5558037d77",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "poi_name": "Genghis Grill",
      "poi_type": "Restaurants",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "genghis-grill",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_056571b8b80b8d5c458816fd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d2a5a4bf05ef3dc9246d4195",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_d33d8ac71cc052adf5b2ee0c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_6c13df49d8be3d0a761be379",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_7ed5492312ca91167d7d7ce4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_77bb291a7a87b871ab6609a5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_b332b36f-2f66-42c5-9dc4-e6346ef50926",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "rating": "5.0",
      "name": "Allison Gilman",
      "text": "I absolutely love living here! The space feels like a home not just an “apartment” and the grounds are always well kept and it’s a beautiful place to be. Maintenance is incredible and so quick to address anything that comes up, trash is always dumped weekly and they keep strict guidelines for everyone in terms of trash, pool etc which keeps it a clean and happy place to be. The office ladies are always amazing too and very helpful! I love living here!",
      "date": "2025-08-20",
      "title": ""
    },
    {
      "id": "custom_7c2f2eea-e7a4-45e6-843f-82629be1f6ae",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "rating": "5.0",
      "name": "Speaklife Positivity",
      "text": "One of the nicest apartments I’ve ever been in! It’s one of my dream places. So clean and they respond so fast to maintenance request. Only one time have I had to remind them and they made sure everything was completed to my standards.",
      "date": "2025-10-10",
      "title": ""
    },
    {
      "id": "custom_d5641075-af75-4c26-a631-bb1fc18d3e07",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "rating": "5.0",
      "name": "Dee Gibbs",
      "text": "Got home after two days drive and air conditioner was not working. It was Sunday night  at 6:30…a cheerful and very competent maintenance man showed up and had me fully restored in half an hour! My experience with this group has been amazing —i have been here a year—excellent front desk service and maintenance team.",
      "date": "2025-09-14",
      "title": ""
    },
    {
      "id": "custom_7923cea4-eb06-4d45-9288-dc932b8464ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "rating": "5.0",
      "name": "Dawn Offutt",
      "text": "My daughter recently moved in! The apartment is spacious! The pool looks amazing! I can't wait to see more of the amenities!!",
      "date": "2025-07-30",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_5335a0cd-e03b-4395-9474-a0b81670ede7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3b-b05d-753a-9d55-6b4bc0798bb8.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360-degree view of apartment complex pool and lounge area",
        "public_id": "019cfb3b-b05d-753a-9d55-6b4bc0798bb8",
        "storage_key": "property/6767906449165589/019cfb3b-b05d-753a-9d55-6b4bc0798bb8.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Cedar Ridge Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=62fe326294cfe83ff1a91482&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-1db2-749b-a047-ff7a7da44c71",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "cedar-ridge-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589"
    },
    {
      "lead_collector_id": "019cf79e-1e27-70cb-84de-b9ea263e2cee",
      "lead_source": "LANDING_PAGE",
      "name": "cedar-ridge-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "apartments-with-pool-south-tulsa",
      "search_query": "apartments with pool in South Tulsa",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in South Tulsa",
      "h2_subtitle": "Discover apartments in South Tulsa featuring a pool. Dive into comfort and leisure at Cedar Ridge Apartments.",
      "page_copy": "If you're seeking apartments with a pool in South Tulsa, Cedar Ridge Apartments is your destination. Experience serene living with the luxury of a refreshing pool and more at our community. Our spacious one, two, and three-bedroom floor plans offer the perfect backdrop for your lifestyle.\n\nBeyond the pool, residents enjoy high ceilings, modern fitness facilities, a clubhouse, and a business center. Located in a prime area of Tulsa, Cedar Ridge Apartments combines comfort, convenience, and community. Schedule a visit today to see firsthand the blend of amenities that make us a standout option in South Tulsa!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in South Tulsa",
      "seo_description": "Discover Cedar Ridge Apartments in South Tulsa with a refreshing pool, fitness center, and more. Schedule a tour today!",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "cedar-ridge-pet-friendly-apartments-tulsa",
      "search_query": "Cedar Ridge pet-friendly apartments Tulsa",
      "category": "Amenity",
      "h1_title": "Cedar Ridge Pet-Friendly Apartments Tulsa",
      "h2_subtitle": "Discover the pet-friendly side of Cedar Ridge Apartments in Tulsa. Your furry friends are welcome here!",
      "page_copy": "Cedar Ridge in Tulsa welcomes you and your pets to our vibrant community. Our pet-friendly apartments offer spacious one, two, and three-bedroom floor plans ideal for all family members, including the furry ones. Whether it's a stroll around our serene courtyards or relaxation in our high-ceilinged rooms, you and your pets will find it easy to make Cedar Ridge Apartments your home.\n\nLocated in South Tulsa, we're close to several parks and pet amenities, making it convenient for your daily walks. Plus, enjoy community features like our modern fitness center, business center, and clubhouse, ensuring a well-rounded living experience. Schedule a visit today and discover how Cedar Ridge Apartments can become your pet-friendly haven in Tulsa!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Ridge Pet-Friendly Apartments Tulsa",
      "seo_description": "Explore Cedar Ridge's pet-friendly apartments in Tulsa. Spacious layouts and amenities make it perfect for you and your pets.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "modern-fitness-center-apartments-74133",
      "search_query": "modern fitness center apartments 74133",
      "category": "Amenity",
      "h1_title": "Apartments with Modern Fitness Center 74133",
      "h2_subtitle": "Find apartments in the 74133 area with a modern fitness center. Cedar Ridge offers state-of-the-art facilities.",
      "page_copy": "Located in Tulsa's 74133 area, Cedar Ridge Apartments offers residents access to a cutting-edge modern fitness center. Whether you're starting a new workout routine or maintaining an existing one, our facilities provide everything you need. Choose from a selection of one, two, and three-bedroom apartments, each designed to complement your lifestyle with comfort and style.\n\nIn addition to the fitness center, residents enjoy a sparkling pool, high ceilings, and a welcoming clubhouse. Nestled in South Tulsa, Cedar Ridge combines convenience, amenities, and a tight-knit community feel. Visit us to see how our state-of-the-art facilities can enhance your daily life and help you achieve your fitness goals.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Modern Fitness Center 74133",
      "seo_description": "Discover Cedar Ridge Apartments with a modern fitness center in Tulsa's 74133. Enjoy top-tier facilities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "controlled-access-apartments-tulsa-ok",
      "search_query": "controlled access apartments Tulsa OK",
      "category": "Amenity",
      "h1_title": "Controlled Access Apartments in Tulsa, OK",
      "h2_subtitle": "Secure your living at Cedar Ridge with controlled access in Tulsa, OK. Discover the peace of mind we offer.",
      "page_copy": "For those seeking controlled access apartments in Tulsa, OK, Cedar Ridge Apartments provides a secure and welcoming environment. Our community prioritizes the safety and comfort of all residents, offering a variety of one, two, and three-bedroom floor plans to suit your needs. Along with security, enjoy amenities like high ceilings and serene courtyards, creating a tranquil living experience.\n\nLocated in vibrant South Tulsa, our apartments combine the benefits of a prime location with unmatched amenities. Enjoy leisurely afternoons by the pool, workouts in the modern fitness center, and social moments in the clubhouse and picnic area. Cedar Ridge Apartments effortlessly blends security with community charm, making it a sought-after choice in Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Controlled Access Apartments in Tulsa, OK",
      "seo_description": "Cedar Ridge offers controlled access apartments in Tulsa, OK. Enjoy security with our excellent amenities in a vibrant community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "apartments-in-unit-washer-dryer-south-tulsa",
      "search_query": "apartments with in-unit washer dryer South Tulsa",
      "category": "Amenity",
      "h1_title": "South Tulsa Apartments with In-Unit Washer Dryer",
      "h2_subtitle": "Experience the convenience of in-unit washer dryers at Cedar Ridge Apartments in South Tulsa, ensuring a hassle-free living.",
      "page_copy": "Cedar Ridge Apartments in South Tulsa offers the convenience of in-unit washer dryers in our spacious one, two, and three-bedroom homes. Enjoy the luxury of doing laundry in the comfort of your own apartment, saving time and adding convenience to your lifestyle. Our community is designed to enhance your living experience with thoughtful amenities.\n\nBeyond the in-unit facilities, Cedar Ridge provides a beautiful setting with high ceilings, a modern fitness center, and a refreshing pool. Located in a prime area of South Tulsa, you'll enjoy easy access to local dining and shopping, along with our welcoming business center and tranquil courtyards. Join our community today and experience the seamless blend of comfort and convenience at Cedar Ridge.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "South Tulsa Apartments with In-Unit Washer Dryer",
      "seo_description": "Discover Cedar Ridge Apartments in South Tulsa with in-unit washer dryers. Comfort and convenience in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-south-tulsa",
      "search_query": "one bedroom apartments in South Tulsa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in South Tulsa",
      "h2_subtitle": "Discover ideal one-bedroom apartments at Cedar Ridge in South Tulsa. Experience comfort and convenience at its best.",
      "page_copy": "If you're searching for one-bedroom apartments in South Tulsa, Cedar Ridge Apartments offers you the ideal blend of comfort and style. Our thoughtfully designed one-bedroom floor plans provide ample space, high ceilings, and modern interiors to make you feel right at home. Whether you're a young professional or downsizing, these apartments cater to a variety of lifestyles.\n\nNestled in vibrant South Tulsa, Cedar Ridge offers more than just a place to live. Enjoy community amenities that include a sparkling pool, modern fitness center, and scenic picnic areas. With a prime location close to shopping and dining options, residents have everything they need within easy reach. Embrace the benefits of living in a welcoming, well-equipped community at Cedar Ridge Apartments today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in South Tulsa",
      "seo_description": "Explore one-bedroom apartments at Cedar Ridge in South Tulsa. Enjoy comfort, amenities, and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-74133",
      "search_query": "two bedroom apartments near 74133",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments Near 74133",
      "h2_subtitle": "Explore spacious two-bedroom apartments at Cedar Ridge, conveniently located near the 74133 area. Find your perfect home today.",
      "page_copy": "Looking for two-bedroom apartments near the 74133 area? Cedar Ridge Apartments offers spacious and thoughtfully designed living spaces perfect for families or roommates. Each apartment comes equipped with modern amenities and features, such as high ceilings and carpeted floors, ensuring a comfortable living environment.\n\nSituated in the heart of South Tulsa, just a stone's throw from the bustling 74133 area, Cedar Ridge provides a tranquil escape with easy access to local attractions. Enjoy the community perks, including a refreshing pool and state-of-the-art fitness center, designed to complement your lifestyle. Experience the best of apartment living at Cedar Ridge today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments Near 74133",
      "seo_description": "Find two-bedroom apartments at Cedar Ridge near 74133. Enjoy spacious living with top amenities in a prime Tulsa location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-tulsa-ok",
      "search_query": "three bedroom apartments Tulsa OK",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Tulsa, OK",
      "h2_subtitle": "Explore spacious three-bedroom apartments at Cedar Ridge in Tulsa, OK, tailored for comfort and convenience.",
      "page_copy": "Discover the perfect home for your family with our three-bedroom apartments in Tulsa, OK, at Cedar Ridge Apartments. These generously sized apartments offer the ideal living arrangements with modern amenities and high ceilings, designed to provide comfort and convenience in every corner.\n\nLocated in the vibrant community of South Tulsa, Cedar Ridge combines luxury with accessibility. Residents can take advantage of the on-site amenities such as a refreshing pool, a state-of-the-art fitness center, and beautifully landscaped courtyards. With easy access to local dining and entertainment options, Cedar Ridge not only offers spacious living but also an active community lifestyle. Find your new home here today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments in Tulsa, OK",
      "seo_description": "Explore three-bedroom apartments at Cedar Ridge in Tulsa, OK. Spacious living with modern amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "cedar-ridge-apartments-near-oral-roberts-university",
      "search_query": "cedar ridge apartments near oral roberts university",
      "category": "School",
      "h1_title": "Cedar Ridge Apartments Near Oral Roberts",
      "h2_subtitle": "Cedar Ridge Apartments offers convenient living near Oral Roberts University. Enjoy modern amenities and easy access to campus and local attractions.",
      "page_copy": "Experience premier apartment living at Cedar Ridge Apartments, located just a short drive from Oral Roberts University. Offering a variety of one, two, and three-bedroom floor plans, Cedar Ridge accommodates a diverse range of lifestyles with ample living spaces and modern amenities, such as a refreshing pool and a state-of-the-art fitness center.\n\nIdeal for students, faculty, or anyone looking to live near campus, Cedar Ridge provides a peaceful living environment with the advantage of proximity to the vibrant life around Oral Roberts University. Our community amenities, including a business center and scenic picnic area, ensure residents have everything they need. Discover the perfect blend of convenience and comfort at our South Tulsa location.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Ridge Apartments Near Oral Roberts",
      "seo_description": "Find Cedar Ridge Apartments near Oral Roberts University. Enjoy modern living with convenient access to campus in Tulsa, OK.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "apartments-near-tulsa-community-college-southeast",
      "search_query": "apartments near tulsa community college southeast campus",
      "category": "School",
      "h1_title": "Apartments Near Tulsa Community College",
      "h2_subtitle": "Discover convenient apartments near Tulsa Community College Southeast Campus at Cedar Ridge. Enjoy easy access and great amenities.",
      "page_copy": "Cedar Ridge Apartments is the ideal choice for those searching for apartments near Tulsa Community College Southeast Campus. Located in South Tulsa, Cedar Ridge offers a range of spacious one, two, and three-bedroom floor plans that are perfect for students, faculty, and staff seeking comfort and convenience.\n\nOur community boasts an array of amenities, including a modern fitness center, sparkling pool, and serene courtyards, providing the perfect environment for relaxation and study. With the college just a short drive away, residents enjoy the ease of attending classes and accessing campus resources. Choose Cedar Ridge Apartments for an enriching living experience near Tulsa Community College.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Tulsa Community College",
      "seo_description": "Find convenient apartments near Tulsa Community College Southeast Campus at Cedar Ridge. Enjoy modern amenities and easy campus access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "south-tulsa-apartments-near-NSU-broken-arrow",
      "search_query": "south tulsa apartments close to northeastern state university broken arrow",
      "category": "School",
      "h1_title": "South Tulsa Apartments Near NSU",
      "h2_subtitle": "Find perfect South Tulsa apartments close to Northeastern State University Broken Arrow at Cedar Ridge. Enjoy modern living with easy commute.",
      "page_copy": "Located in the heart of South Tulsa, Cedar Ridge Apartments offers the perfect blend of modern comfort and accessibility for students and professionals seeking apartments near Northeastern State University Broken Arrow. Our one, two, and three-bedroom floor plans are designed with your lifestyle in mind, featuring high ceilings and inviting interiors.\n\nCedar Ridge provides an enriching community environment with amenities like a fitness center, pool, and business center, suited to complement both academic and professional lifestyles. Situated a convenient drive away from Northeastern State University Broken Arrow, our residents enjoy the luxury of a quick and easy commute, making Cedar Ridge an ideal home base for students and faculty alike.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "South Tulsa Apartments Near NSU",
      "seo_description": "Explore South Tulsa apartments near Northeastern State University Broken Arrow at Cedar Ridge. Enjoy easy commuting and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "apartments-near-saint-francis-hospital-tulsa",
      "search_query": "apartments near saint francis hospital tulsa",
      "category": "Hospital",
      "h1_title": "Apartments Near Saint Francis Hospital Tulsa",
      "h2_subtitle": "Explore Cedar Ridge Apartments near Saint Francis Hospital in Tulsa. Enjoy convenient living with top-notch amenities and quick hospital access.",
      "page_copy": "Cedar Ridge Apartments, situated in South Tulsa, is an excellent choice for healthcare professionals and families seeking apartments near Saint Francis Hospital. Our community offers spacious and modern one, two, and three-bedroom floor plans that fit the needs of busy lifestyles with ease.\n\nResidents at Cedar Ridge enjoy an array of community amenities including a refreshing pool, contemporary fitness center, and serene courtyards, perfect for relaxing after a long day. The proximity to Saint Francis Hospital makes daily commutes straightforward and stress-free. Experience the blend of comfort and convenience at Cedar Ridge Apartments—your peaceful retreat near the heart of Tulsa's medical community.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Saint Francis Hospital Tulsa",
      "seo_description": "Find Cedar Ridge Apartments near Saint Francis Hospital. Enjoy modern amenities and comfortable living close to healthcare facilities in Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "apartments-close-to-hillcrest-south-tulsa",
      "search_query": "apartments close to hillcrest south south tulsa",
      "category": "Hospital",
      "h1_title": "Apartments Close to Hillcrest South",
      "h2_subtitle": "Discover Cedar Ridge Apartments, conveniently close to Hillcrest South in South Tulsa. Enjoy modern living with easy hospital access.",
      "page_copy": "At Cedar Ridge Apartments, located in South Tulsa, residents find an ideal living location close to Hillcrest South. Our community features a selection of spacious one, two, and three-bedroom floor plans, perfect for healthcare professionals and families seeking convenience.\n\nCedar Ridge offers a host of amenities designed to enhance your lifestyle, including a modern fitness center, refreshing pool, and relaxing courtyards. With Hillcrest South just a short drive away, residents enjoy quick access to healthcare services and their work environment. Choose Cedar Ridge Apartments for a blend of comfortable living and exceptional location benefits near hospitals in Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Hillcrest South Tulsa",
      "seo_description": "Find comfortable Cedar Ridge Apartments close to Hillcrest South in South Tulsa. Offering modern amenities and convenient hospital access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "apartments-near-rhema-park-tulsa",
      "search_query": "apartments near Rhema Park Tulsa",
      "category": "Park",
      "h1_title": "Apartments Near Rhema Park Tulsa",
      "h2_subtitle": "Explore Cedar Ridge Apartments near Rhema Park in Tulsa. Enjoy serene living with access to beautiful park spaces and modern comforts.",
      "page_copy": "Cedar Ridge Apartments offers an unbeatable combination of convenience and comfort in South Tulsa, with prime location accessibility to Rhema Park. Choose from our thoughtfully designed one, two, and three-bedroom floor plans, ideal for individuals and families eager to enjoy nearby outdoor activities.\n\nLiving at Cedar Ridge means having access to a wide range of amenities, including a fitness center, swimming pool, and welcoming courtyards. Rhema Park, located nearby, offers residents a natural escape for relaxation and recreation. Cedar Ridge Apartments stands out as the perfect home ground combining tranquility with modern living, all within reach of Tulsa's scenic attractions.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rhema Park Tulsa",
      "seo_description": "Discover Cedar Ridge Apartments near Rhema Park in Tulsa. Enjoy modern living and quick access to beautiful outdoor spaces.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "apartments-close-to-elam-park-74133",
      "search_query": "apartments close to Elam Park 74133",
      "category": "Park",
      "h1_title": "Apartments Close to Elam Park 74133",
      "h2_subtitle": "Discover Cedar Ridge Apartments near Elam Park in the 74133 area. Enjoy a vibrant community with easy park access and modern comforts.",
      "page_copy": "Cedar Ridge Apartments in South Tulsa offers a superb location close to Elam Park, perfect for those seeking a vibrant community within the 74133 area. Our spacious one, two, and three-bedroom floor plans are ideal for individuals and families who value both comfort and proximity to green spaces.\n\nResidents at Cedar Ridge enjoy several amenities, including a well-equipped fitness center, a refreshing swimming pool, and beautifully maintained courtyards. Elam Park, just around the corner, provides an excellent venue for outdoor recreation and leisure. Choose Cedar Ridge Apartments, where contemporary living meets the charm of nearby parks and natural beauty.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Elam Park 74133",
      "seo_description": "Find Cedar Ridge Apartments near Elam Park in the 74133 area. Enjoy modern amenities and seamless access to park facilities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "multifamily-near-lafortune-park-south-tulsa",
      "search_query": "multifamily near LaFortune Park South Tulsa",
      "category": "Park",
      "h1_title": "Multifamily Near LaFortune Park Tulsa",
      "h2_subtitle": "Explore multifamily living at Cedar Ridge Apartments near LaFortune Park in South Tulsa. Enjoy vibrant and convenient community living.",
      "page_copy": "Cedar Ridge Apartments presents a premier multifamily living opportunity, perfectly situated near LaFortune Park in South Tulsa. Our community features a range of spacious one, two, and three-bedroom apartments, allowing families and individuals easy access to the area's abundant recreational facilities.\n\nWithin Cedar Ridge, residents indulge in amenities such as a modern fitness center, a refreshing swimming pool, and lush courtyards designed for relaxation. The close proximity to LaFortune Park offers a myriad of outdoor activities, including trails, golf, and playgrounds. Choose Cedar Ridge Apartments for a harmonious blend of community-focused living and natural beauty in South Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Multifamily Near LaFortune Park Tulsa",
      "seo_description": "Discover multifamily living at Cedar Ridge near LaFortune Park in South Tulsa. Enjoy great amenities and easy access to park activities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "living-near-hunter-park-tulsa-ok",
      "search_query": "living near Hunter Park Tulsa OK",
      "category": "Park",
      "h1_title": "Living Near Hunter Park Tulsa, OK",
      "h2_subtitle": "Experience life at Cedar Ridge Apartments near Hunter Park, Tulsa, OK. Enjoy community comforts and proximity to nature.",
      "page_copy": "Explore a seamless balance of modern living and natural beauty at Cedar Ridge Apartments, located conveniently near Hunter Park in Tulsa, OK. Our collection of spacious one, two, and three-bedroom apartments is crafted for those who appreciate comfort and accessibility to Tulsa's serene outdoor spaces.\n\nCedar Ridge Apartments offers a range of amenities, including a state-of-the-art fitness center, a refreshing pool, and welcoming picnic areas. With Hunter Park just a short distance away, residents can indulge in scenic walking paths, playgrounds, and open green spaces. Embrace a lifestyle where contemporary living meets the tranquility of nature at Cedar Ridge Apartments.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Near Hunter Park Tulsa, OK",
      "seo_description": "Discover Cedar Ridge Apartments near Hunter Park, Tulsa, OK. Enjoy modern amenities and a tranquil community setting close to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165589",
      "source": "generator",
      "page_item_url": "south-tulsa-apartments-by-haikey-creek-park",
      "search_query": "South Tulsa apartments by Haikey Creek Park",
      "category": "Park",
      "h1_title": "South Tulsa Apartments by Haikey Creek Park",
      "h2_subtitle": "Find your home at Cedar Ridge Apartments near Haikey Creek Park in South Tulsa. Enjoy easy access to outdoor adventures and upscale amenities.",
      "page_copy": "Cedar Ridge Apartments in South Tulsa offers a prime location near Haikey Creek Park, perfect for those who seek a dynamic space with easy access to nature. Our selection of spacious one, two, and three-bedroom apartments is ideal for families and individuals who value both style and convenience.\n\nResidents enjoy a suite of complete amenities, including high ceilings, a modern fitness center, and a charming picnic area. The proximity to Haikey Creek Park provides endless opportunities for outdoor activities, from tranquil walks to lively playground fun. Make Cedar Ridge Apartments your next home and enjoy the perfect blend of modern amenities with the allure of nearby natural spaces.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
      "featured_image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and sun umbrellas.",
        "public_id": "019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb",
        "storage_key": "property/6767906449165589/019cfb3a-ba6b-70cb-b537-0bd4d5d43bbb.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "South Tulsa Apartments by Haikey Creek Park",
      "seo_description": "Discover Cedar Ridge Apartments by Haikey Creek Park, South Tulsa. Enjoy abundant amenities and nearby park adventures.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5152"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-7C5X70GPE0"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151661"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/cedar-ridge/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-PJ7S8VG7"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165589/019d1bd7-3562-740e-84e3-3ae3c8581d9a.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "d2adc2b9-5c0f-4c49-86dd-402f31720e1f"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "866-723-1390"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "64554bd6e5597ef488e679e4"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IkliTnVtNkVQeklDbDhoR1ZwQ3FnUnc9PSIsInZhbHVlIjoiS1pLMThMdEJxWE1vR2d2VDcxazVjZz09IiwibWFjIjoiNjBjN2FkOWVmZmQ5NWU5ZGMxMTFhNzJhOTY1OTFiOTkyNTUyZGJmZTU3MjU1MDMzMDAwMzViNTRkMzc1OGFjNSJ9"
    }
  ],
  "custom_qb_id": "5152",
  "custom_ga4_id": "G-7C5X70GPE0",
  "custom_repli_id": "10041151661",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/cedar-ridge/register/",
  "custom_google_gtm_id": "GTM-PJ7S8VG7",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165589/019d1bd7-3562-740e-84e3-3ae3c8581d9a.pdf",
  "custom_rentgrata_property_id": "d2adc2b9-5c0f-4c49-86dd-402f31720e1f",
  "custom_ppc_tracking_phone_number": "866-723-1390",
  "custom_residentboost_apartment_id": "64554bd6e5597ef488e679e4",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IkliTnVtNkVQeklDbDhoR1ZwQ3FnUnc9PSIsInZhbHVlIjoiS1pLMThMdEJxWE1vR2d2VDcxazVjZz09IiwibWFjIjoiNjBjN2FkOWVmZmQ5NWU5ZGMxMTFhNzJhOTY1OTFiOTkyNTUyZGJmZTU3MjU1MDMzMDAwMzViNTRkMzc1OGFjNSJ9"
};

export const generatedAt = '2026-09-10T15:42:00.990Z';
